<template>
	<div class="dashboard" style="font-size: 14px; margin-top: 10px">
		<template v-if="isDomLoading">
			<TaskSkeletonLoader />
		</template>
		<div
			:style="isDomLoading ? 'visibility: hidden; height: 1px' : ''"
			v-if="current_view == 'Page_1'"
		>
			<el-card shadow="none">
				<div>
					<div style="display: flex; flex-wrap: wrap">
						<div style="flex: 0 0 calc(15% - 20px); margin-right: 20px">
							<div>View By</div>
							<el-select
								style="margin-top: 10px"
								class="select"
								v-model="view_by"
								filterable
								placeholder="View By"
								@change="listDashboardData"
							>
								<el-option
									v-for="(item, key) in view_byItems"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</div>

						<div style="flex: 0 0 calc(30% - 20px); margin-right: 20px">
							<span
								>Location
								<span
									@click="selectedLocationType = 'location'"
									style="font-size: 13px; cursor: pointer; margin-left: 30px"
									:style="
										selectedLocationType == 'location'
											? 'text-decoration: underline;color:#d26300;font-weight:bolder'
											: 'color:#d26300;'
									"
									>All Location
								</span>
								<span style="color: #d26300"> | </span>
								<span
									@click="selectedLocationType = 'region'"
									style="font-size: 13px; cursor: pointer"
									:style="
										selectedLocationType == 'region'
											? 'text-decoration: underline;color:#d26300;font-weight:bolder'
											: 'color:#d26300;'
									"
									>By Region</span
								>
							</span>
							<el-cascader
								v-if="selectedLocationType == 'region'"
								popper-class="ns-custom-cascader ns-ticket"
								style="width: 100%; border-radius: 12px; margin-top: 10px"
								placeholder="Select Locations"
								:options="locationItems"
								:props="{
									multiple: true,
									checkStrictly: true,
									expandTrigger: 'hover',
								}"
								v-model="locations"
								filterable
								clearable
								:collapse-tags="true"
								@change="listDashboardData"
								id="cascader"
							></el-cascader>
							<el-select
								v-if="selectedLocationType == 'location'"
								style="margin-top: 10px"
								class="select"
								v-model="locations"
								filterable
								:multiple="true"
								:clearable="true"
								placeholder="Select Locations"
								@change="listDashboardData"
							>
								<el-option
									v-for="(item, key) in all_locations"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<!-- Your Location content here -->
						</div>

						<div style="flex: 0 0 calc(25% - 20px); margin-right: 20px">
							<div>Report</div>
							<el-select
								style="margin-top: 10px"
								class="select"
								v-model="reports"
								filterable
								placeholder="Select Report"
							>
								<el-option
									v-for="(item, key) in reportItems"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<!-- Your Report content here -->
						</div>
						<div
							v-if="
								reports != 'month_on_month' && reports != 'quarter_on_quarter'
							"
							style="flex: 0 0 calc(15% - 20px); margin-right: 20px"
						>
							<div>
								<div>From</div>
								<el-date-picker
									style="margin-top: 10px; width: 95%"
									v-model="from_date"
									type="date"
									placeholder="Select Date"
									class="date"
									format="yyyy-MM-dd"
									@change="listDashboardData"
									:picker-options="datePickerOptions"
									:disabled="reports != 'custom_date'"
								>
									<!-- 
							:disabled="reports != 'custom_date'"

						 -->
								</el-date-picker>
							</div>
						</div>
						<div
							v-if="
								reports != 'month_on_month' && reports != 'quarter_on_quarter'
							"
							style="flex: 0 0 calc(15% - 20px); margin-right: 20px"
						>
							<div>
								<div>To</div>
								<el-date-picker
									style="margin-top: 10px; width: 95%"
									v-model="to_date"
									type="date"
									placeholder="Select Date"
									class="date"
									format="yyyy-MM-dd"
									@change="listDashboardData"
									:picker-options="fromDatePickerOptions"
									:disabled="reports != 'custom_date'"
								>
								</el-date-picker>
							</div>
						</div>
						<div
							v-if="
								reports == 'month_on_month' || reports == 'quarter_on_quarter'
							"
							style="flex: 0 0 calc(15% - 20px); margin-right: 20px"
						>
							<div>
								<div>From</div>
								<el-date-picker
									style="margin-top: 10px; width: 95%"
									v-model="from_date"
									placeholder="Select Date"
									class="date"
									format="yyyy-MM-dd"
									@change="listDashboardData"
									:picker-options="datePickerOptions"
									type="month"
								>
									<!-- 
							:disabled="reports != 'custom_date'"

						 -->
								</el-date-picker>
							</div>
						</div>
						<div
							v-if="
								reports == 'month_on_month' || reports == 'quarter_on_quarter'
							"
							style="flex: 0 0 calc(15% - 20px); margin-right: 20px"
						>
							<div>
								<div>To</div>
								<el-date-picker
									style="margin-top: 10px; width: 95%"
									v-model="to_date"
									placeholder="Select Date"
									class="date"
									format="yyyy-MM-dd"
									@change="listDashboardData"
									:picker-options="fromDatePickerOptions"
									type="month"
								>
								</el-date-picker>
							</div>
						</div>
						<!-- Add more divs for other sections as needed -->
					</div>
				</div>
				<div style="margin-top: 15px">
					<div style="display: flex; flex-wrap: wrap">
						<div style="flex: 0 0 calc(45% - 20px); margin-right: 20px">
							<div>Project and Tasks</div>
							<el-select
								style="margin-top: 10px"
								class="select"
								v-model="project_tasks"
								filterable
								placeholder="Select Project and Tasks"
								@change="getCategory(project_tasks)"
							>
								<el-option
									v-for="(item, key) in project_tasksItems"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</div>
						<div style="flex: 0 0 calc(25% - 20px); margin-right: 20px">
							<div>Category</div>
							<el-select
								style="margin-top: 10px"
								class="select"
								v-model="category"
								filterable
								placeholder="Select Category"
								@change="getForms(category)"
							>
								<el-option
									v-for="(item, key) in categoryItems"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</div>
						<div style="flex: 0 0 calc(30% - 20px); margin-right: 20px">
							<div>Form</div>
							<el-select
								style="margin-top: 10px"
								class="select"
								v-model="forms"
								filterable
								placeholder="Select Form"
								@change="listDashboardData"
							>
								<el-option
									v-for="(item, key) in formItems"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
			</el-card>
			<!-- <el-row
				style="font-size: 16px; margin-top: 20px; margin-bottom: 10px"
				:gutter="10"
			>
				<el-col :span="24">
					<span style="margin-left: 100px"><b>Active</b></span
					><span style="margin-left: 10px; color: #d26300">
						<b>{{ summaryData.active }}</b></span
					>
					<span style="margin-left: 100px"><b>Completed</b></span
					><span style="margin-left: 10px; color: #d26300">
						<b>{{ summaryData.completed }}</b></span
					>
					<span style="margin-left: 100px"><b>Due Today </b></span
					><span style="margin-left: 10px; color: #d26300"
						><b>{{ summaryData.due_today }}</b></span
					>
					<span style="margin-left: 100px"><b>Overdue</b></span
					><span style="margin-left: 10px; color: #d26300"
						><b>{{ summaryData.overdue }}</b></span
					>
					<span style="margin-left: 100px"><b>Actions</b></span
					><span style="margin-left: 10px; color: #d26300"
						><b>{{ summaryData.actions_count }}</b></span
					>
					<span style="margin-left: 100px"><b>Completion Rate</b></span
					><span style="margin-left: 10px; color: #d26300"
						><b>{{ (summaryData.completion_rate * 100).toFixed(2) }}%</b></span
					>
				</el-col>
			</el-row> -->
			<div
				style="
					display: flex;
					flex-wrap: wrap;
					margin-top: 20px;
					margin-bottom: 10px;
				"
			>
				<div
					style="
						flex: 0 0 calc(15% - 20px);
						margin-right: 20px;
						margin-bottom: 10px;
					"
				>
					<div style="font-size: 16px; display: flex">
						<span style="margin-left: 10px"><b>Active</b></span>
						<span style="margin-left: 10px; color: #d26300"
							><b>{{ summaryData.active }}</b></span
						>
					</div>
				</div>
				<div
					style="
						flex: 0 0 calc(15% - 20px);
						margin-right: 20px;
						margin-bottom: 10px;
					"
				>
					<div style="font-size: 16px; display: flex">
						<span style="margin-left: 10px"><b>Completed</b></span>
						<span style="margin-left: 10px; color: #d26300"
							><b>{{ summaryData.completed }}</b></span
						>
					</div>
				</div>
				<!-- <div
					style="
						flex: 0 0 calc(15% - 20px);
						margin-right: 20px;
						margin-bottom: 10px;
					"
				>
					<div style="font-size: 16px; display: flex">
						<span style="margin-left: 10px"><b>Due Today</b></span>
						<span style="margin-left: 10px; color: #d26300"
							><b>{{ summaryData.due_today }}</b></span
						>
					</div>
				</div>
				<div
					style="
						flex: 0 0 calc(15% - 20px);
						margin-right: 20px;
						margin-bottom: 10px;
					"
				>
					<div style="font-size: 16px; display: flex">
						<span style="margin-left: 10px"><b>Overdue</b></span>
						<span style="margin-left: 10px; color: #d26300"
							><b>{{ summaryData.overdue }}</b></span
						>
					</div>
				</div>
				<div
					style="
						flex: 0 0 calc(15% - 20px);
						margin-right: 20px;
						margin-bottom: 10px;
					"
				>
					<div style="font-size: 16px; display: flex">
						<span style="margin-left: 10px"><b>Actions</b></span>
						<span style="margin-left: 10px; color: #d26300"
							><b>{{ summaryData.actions_count }}</b></span
						>
					</div>
				</div> -->
				<div
					style="
						flex: 0 0 calc(25% - 20px);
						margin-right: 20px;
						margin-bottom: 10px;
					"
				>
					<div style="font-size: 16px; display: flex">
						<span style="margin-left: 10px"><b>Completion Rate</b></span>
						<span style="margin-left: 10px; color: #d26300"
							><b
								>{{ (summaryData.completion_rate * 100).toFixed(2) }}%</b
							></span
						>
					</div>
				</div>
			</div>
			<div style="background: white; padding: 5px">
				<el-row
					style="font-size: 16px; margin-top: 20px; text-align: center"
					:gutter="10"
				>
					<el-col :span="24">
						<div style="">
							<el-row style="text-align: center">
								<el-col :span="10" :offset="6">
									<b>Performance - By {{ view_by }}</b>
								</el-col>
								<!-- <el-col :span="3">
									<el-select
										class="select"
										v-model="selectType"
										filterable
										placeholder="Select"
										@change="listDashboardData"
									>
										<el-option
											v-for="(item, key) in selectTypeItems"
											:key="key"
											:label="item.name"
											:value="item.id"
										>
										</el-option>
									</el-select>
								</el-col> -->
							</el-row>
							<el-row
								v-if="
									reports == 'custom_date' ||
									reports == 'year_to_date' ||
									reports == 'month_to_date' ||
									reports == 'week_to_date'
								"
								style="text-align: center; margin-top: 5px"
							>
								<el-col :span="7" :offset="7">
									<el-row :gutter="10">
										<el-col :span="1">
											<div
												style="
													height: 12px;
													width: 12px;
													background-color: #d26300;
												"
											></div>
										</el-col>
										<el-col :span="5">
											<div style="font-size: 13px">Score %</div>
										</el-col>
										<el-col :span="1" :offset="2">
											<div
												style="
													height: 12px;
													width: 12px;
													background-color: #ffc897;
												"
											></div>
										</el-col>
										<el-col :span="7">
											<div style="font-size: 13px">Completion %</div>
										</el-col>
										<el-col :span="2" :offset="2">
											<div style="border-top: 3px dashed #7daaf4"></div>
										</el-col>
										<el-col style="margin-left: -10px" :span="9">
											<div style="font-size: 13px">Country Average</div>
										</el-col>
									</el-row>
								</el-col>
							</el-row>
						</div>
						<div v-if="project_tasksItems.length == 0">
							<div
								style="
									text-align: center;
									margin-top: 50px;
									margin-bottom: 10px;
								"
							>
								<img src="../../../../assets/images/Union.png" />
							</div>
							<div
								style="
									text-align: center;
									font-weight: 200;
									margin-bottom: 50px;
								"
							>
								There is nothing to show you right now
							</div>
						</div>
						<div v-else style="margin-top: 10px">
							<PerformanceGraphVue
								v-if="
									reports == 'quarter_on_quarter' || reports == 'month_on_month'
								"
								:reports-table="reportsTable"
								:labels-data="JSON.stringify(labels)"
								:dataList="dataList"
								:CountryAverege="CountryAverege"
								:show_report="show_report"
								@set_show_false="show_report = false"
								:selectType="selectType"
								:reports="reports"
								:mom_table_data="mom_table_data"
								:all_location_list="all_location_list"
								:show_completion="show_completion"
								:show_score="show_score"
							/>
							<PerformanceGraphNonMonthVue
								v-if="
									reports == 'custom_date' ||
									reports == 'year_to_date' ||
									reports == 'month_to_date' ||
									reports == 'week_to_date'
								"
								:reports-table="reportsTable"
								:labels-data="JSON.stringify(labels)"
								:dataList="dataList"
								:CountryAverege="CountryAverege"
								:show_report="show_report"
								@set_show_false="show_report = false"
								:selectType="selectType"
								:reports="reports"
								:mom_table_data="mom_table_data"
								:all_location_list="all_location_list"
								:show_fields="show_fields"
								:report_type="report_type"
							/>
						</div>
					</el-col>
					<!-- <el-col
						:style="
							project_tasksItems.length == 0
								? 'margin-top: -100px'
								: 'margin-top: -250px'
						"
						:span="4"
					>
						<el-select
							class="select"
							v-model="selectType"
							filterable
							placeholder="Select"
							@change="listDashboardData"
						>
							<el-option
								v-for="(item, key) in selectTypeItems"
								:key="key"
								:label="item.name"
								:value="item.id"
							>
							</el-option>
						</el-select>
						<el-row style="margin-top: 20px">
							<el-col :span="3">
								<div
									style="height: 15px; width: 15px; background-color: #ee9683"
								></div>
							</el-col>
							<el-col :span="21">
								<div>Score %</div>
							</el-col>
						</el-row>
						<el-row style="margin-top: 10px">
							<el-col :span="2">
								<div style="border-top: 3px dashed #7daaf4"></div>
							</el-col>
							<el-col :span="21" :offset="1">
								<div>Country Average</div>
							</el-col>
						</el-row>
					</el-col> -->
				</el-row>
			</div>
			<div
				v-if="!view_month_table"
				style="margin-top: 20px; background: white; padding: 5px"
			>
				<el-row>
					<el-col :span="10">
						<span style="font-weight: bold">
							Reports -
							{{
								project_tasksItems.length != 0
									? project_tasksItems.filter((el) =>
											el.id.includes(project_tasks)
									  )[0].name
									: "-"
							}}
							<br />
							( {{ moment(from_date).format("Do MMM YYYY") }} -
							{{ moment(to_date).format("Do MMM YYYY") }} )</span
						>
					</el-col>

					<el-col :span="4" style="margin-left: 20px">
						<input
							type="text"
							v-model="search"
							:placeholder="`Search ${
								view_by == 'Location' ? 'Location' : 'User'
							}`"
							class="searchicon"
						/>
					</el-col>
					<el-col :span="4" style="margin-left: 20px">
						<el-select
							class="select"
							v-model="report_type"
							filterable
							placeholder="Select Report Type"
							@change="listReportsSwitchData"
						>
							<el-option value="Consolidated Report">
								Consolidated Report
							</el-option>
							<el-option value="Project / Task - Breakup Report"
								>Project / Task - Breakup Report
							</el-option>
							<el-option value="Detailed Report"> Detailed Report </el-option>
							<!-- <el-option value="Vertical Detailed Report">
								Vertical Detailed Report
							</el-option> -->
						</el-select>
					</el-col>
					<el-col :span="5">
						<el-button
							icon="el-icon-download"
							style="margin-top: -20px; margin-left: 20px"
							class="button-class"
							@click="exportCSV"
						>
							Download Reports
						</el-button>
					</el-col>
				</el-row>
				<el-row
					v-if="report_type == 'Consolidated Report'"
					v-loading="isloading"
					class="reports-table-hide"
					style="margin-top: 14px; hidden"
				>
					<el-col :span="24">
						<el-table
							:show-header="true"
							style="text-transform: capitalize"
							:data="
								filteredreportsTable

									.filter(
										(el) =>
											!selected_Location.length ||
											selected_Location.includes(el.name)
									)
									.filter(
										(el) =>
											!search ||
											el.name.toLowerCase().includes(search.toLowerCase())
									)
									.filter(
										(el, index) => index >= startNumber - 1 && index < endNumber
									)
							"
						>
							<el-table-column label="Location">
								<template slot="header" slot-scope="scope">
									{{ view_by == "Location" ? "Location" : "User" }}
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_Location"
											size="mini"
											:placeholder="`Search ${
												view_by == 'Location' ? 'Location' : 'User'
											}`"
										></el-input>
										<div
											style="
												max-height: 250px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group v-model="selected_Location">
												<el-checkbox
													v-for="(
														formItem, index
													) in uniqueLocationNames.filter(
														(el) =>
															!searched_Location ||
															el
																.toLowerCase()
																.includes(searched_Location.toLowerCase())
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formItem"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selected_Location = [...uniqueLocationNames]"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_Location = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_Location.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
							</el-table-column>
							<el-table-column prop="total" label="Total Projects">
								<template slot="header" slot-scope="scope">
									Total Projects
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_occurance_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											@click="
												last_occurance_order = 'asc';
												last_completed_order = '';
												last_completion_order = '';
												last_total_points_order = '';
												last_points_achieved_oeder = '';
												last_score_order = '';
												last_average_score_order = '';
											"
										></i>
										<i
											v-if="
												last_occurance_order == '' ||
												last_occurance_order == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											@click="
												last_occurance_order = 'desc';
												last_completed_order = '';
												last_total_points_order = '';
												last_completion_order = '';
												last_points_achieved_oeder = '';
												last_score_order = '';
												last_average_score_order = '';
											"
										></i>
									</span>
								</template>
							</el-table-column>
							<el-table-column prop="completed" label="Completed">
								<template slot="header" slot-scope="scope">
									Completed
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_completed_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											@click="
												last_occurance_order = '';
												last_completed_order = 'asc';
												last_completion_order = '';
												last_total_points_order = '';
												last_points_achieved_oeder = '';
												last_score_order = '';
												last_average_score_order = '';
											"
										></i>
										<i
											v-if="
												last_completed_order == '' ||
												last_completed_order == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											@click="
												last_occurance_order = '';
												last_completed_order = 'desc';
												last_total_points_order = '';
												last_completion_order = '';
												last_points_achieved_oeder = '';
												last_score_order = '';
												last_average_score_order = '';
											"
										></i>
									</span>
								</template>
							</el-table-column>
							<el-table-column
								v-if="show_completion"
								prop="completion_%"
								label="Completion %"
							>
								<!-- <template slot-scope="scope">
									<div>{{ scope.row["completion_%"] }}%</div>
								</template> -->

								<template slot="header" slot-scope="scope">
									Completion %
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_completion_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											@click="
												last_occurance_order = '';
												last_completed_order = '';
												last_completion_order = 'asc';
												last_total_points_order = '';
												last_points_achieved_oeder = '';
												last_score_order = '';
												last_average_score_order = '';
											"
										></i>
										<i
											v-if="
												last_completion_order == '' ||
												last_completion_order == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											@click="
												last_occurance_order = '';
												last_completed_order = '';
												last_completion_order = 'desc';
												last_total_points_order = '';
												last_points_achieved_oeder = '';
												last_score_order = '';
												last_average_score_order = '';
											"
										></i>
									</span>
								</template>
							</el-table-column>
							<el-table-column
								v-if="show_score"
								prop="completed_score_%"
								label="Completion %"
							>
								<!-- <template slot-scope="scope">
									<div>{{ scope.row["completion_%"] }}%</div>
								</template> -->

								<template slot="header" slot-scope="scope">
									Score %
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_score_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											@click="
												last_occurance_order = '';
												last_completed_order = '';
												last_completion_order = '';
												last_total_points_order = '';
												last_points_achieved_oeder = '';
												last_average_score_order = '';
												last_score_order = 'asc';
											"
										></i>
										<i
											v-if="last_score_order == '' || last_score_order == 'asc'"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											@click="
												last_occurance_order = '';
												last_completed_order = '';
												last_completion_order = '';
												last_total_points_order = '';
												last_points_achieved_oeder = '';
												last_average_score_order = '';
												last_score_order = 'desc';
											"
										></i>
									</span>
								</template>
							</el-table-column>
							<el-table-column
								v-if="show_score"
								prop="completed_total_score"
								label="Total Points"
							>
								<template slot="header" slot-scope="scope">
									Total Points
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_total_points_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											@click="
												last_occurance_order = '';
												last_completed_order = '';
												last_completion_order = '';
												last_total_points_order = 'asc';
												last_points_achieved_oeder = '';
												last_score_order = '';
												last_average_score_order = '';
											"
										></i>
										<i
											v-if="
												last_total_points_order == '' ||
												last_total_points_order == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											@click="
												last_occurance_order = '';
												last_completed_order = '';
												last_completion_order = '';
												last_total_points_order = 'desc';
												last_points_achieved_oeder = '';
												last_score_order = '';
												last_average_score_order = '';
											"
										></i>
									</span>
								</template>
							</el-table-column>
							<el-table-column
								v-if="show_score"
								prop="completed_current_score"
								label="Points Achieved"
							>
								<template slot="header" slot-scope="scope">
									Points Achieved
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_points_achieved_oeder == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											@click="
												last_occurance_order = '';
												last_completed_order = '';
												last_completion_order = '';
												last_total_points_order = '';
												last_points_achieved_oeder = 'asc';
												last_score_order = '';
												last_average_score_order = '';
											"
										></i>
										<i
											v-if="
												last_points_achieved_oeder == '' ||
												last_points_achieved_oeder == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											@click="
												last_occurance_order = '';
												last_completed_order = '';
												last_completion_order = '';
												last_total_points_order = '';
												last_points_achieved_oeder = 'desc';
												last_score_order = '';
												last_average_score_order = '';
											"
										></i>
									</span>
								</template>
							</el-table-column>
							<!-- <el-table-column
								prop="completed_score_%"
								label="Average Score %"
								v-if="show_score"
							>
								<template slot="header" slot-scope="scope">
									Average Score %
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_average_score_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											@click="
												last_occurance_order = '';
												last_completed_order = '';
												last_completion_order = '';
												last_total_points_order = '';
												last_points_achieved_oeder = '';
												last_average_score_order = 'asc';
												last_score_order = '';
											"
										></i>
										<i
											v-if="
												last_average_score_order == '' ||
												last_average_score_order == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											@click="
												last_occurance_order = '';
												last_completed_order = '';
												last_completion_order = '';
												last_total_points_order = '';
												last_points_achieved_oeder = '';
												last_score_order = '';
												last_average_score_order = 'desc';
											"
										></i>
									</span>
								</template>
							</el-table-column> -->
						</el-table>
					</el-col>
				</el-row>
				<el-row
					v-if="report_type == 'Consolidated Report'"
					v-loading="isloading"
					class="reports-table-hide"
					style="margin-top: 0px"
				>
					<el-col :span="24">
						<el-table
							:show-header="true"
							style="text-transform: capitalize"
							:data="SummaryreportsTable"
						>
							<el-table-column>
								<template slot="header" slot-scope="scope">
									<div
										:style="
											selectedLocationType == 'region'
												? 'text-decoration: underline;cursor: pointer'
												: ''
										"
										@click="
											view_by == 'Location' && selectedLocationType == 'region'
												? open_report_dashboard(
														scope.row,
														scope.$index,
														'TOTAL'
												  )
												: ''
										"
									>
										India
									</div>
								</template>
							</el-table-column>
							<el-table-column
								:label="get_reports_label('occurance').toString()"
							>
							</el-table-column>
							<el-table-column
								:label="get_reports_label('completed').toString()"
							>
							</el-table-column>
							<el-table-column
								v-if="show_completion"
								:label="get_reports_label('completion').toString()"
							>
							</el-table-column>
							<el-table-column
								v-if="show_score"
								:label="get_reports_label('score').toString()"
							>
							</el-table-column>
							<el-table-column
								v-if="show_score"
								:label="get_reports_label('total').toString()"
							>
							</el-table-column>
							<el-table-column
								v-if="show_score"
								:label="get_reports_label('achieved').toString()"
							>
							</el-table-column>
							<!-- <el-table-column
								v-if="show_score"
								:label="get_reports_label('score').toString()"
							>
							</el-table-column> -->
						</el-table>
					</el-col>
				</el-row>
				<el-row
					v-if="report_type == 'Consolidated Report'"
					v-loading="isloading"
					class="reports-table"
					style=""
				>
					<el-col :span="24">
						<el-table
							:show-header="false"
							style="text-transform: capitalize"
							:data="
								reportsTable

									.filter(
										(el) =>
											!selected_Location.length ||
											selected_Location.includes(el.name)
									)
									.filter(
										(el) =>
											!search ||
											el.name.toLowerCase().includes(search.toLowerCase())
									)
									.filter(
										(el, index) => index >= startNumber - 1 && index < endNumber
									)
							"
						>
							<el-table-column label="Location">
								<template slot-scope="scope">
									<div
										@click="
											view_by == 'Location'
												? open_report_dashboard(scope.row, scope.$index, 'ROW')
												: ''
										"
										:style="
											view_by == 'Location'
												? `text-transform: capitalize;
											margin-top: -5px;
											color: #d26300;
											cursor: pointer;
											word-break: break-word;`
												: `text-transform: capitalize;
											margin-top: -5px;
											word-break: break-word;`
										"
									>
										{{ scope.row.name }}
									</div>
								</template>
							</el-table-column>
							<el-table-column sortable prop="total" label="Occurence">
							</el-table-column>
							<el-table-column sortable prop="completed" label="Completed">
							</el-table-column>
							<el-table-column
								v-if="show_completion"
								sortable
								prop="completion_%"
								label="Completion %"
							>
								<template slot-scope="scope">
									<div>{{ scope.row["completion_%"] }}%</div>
								</template>
							</el-table-column>
							<el-table-column
								sortable
								prop="completed_score_%"
								label=""
								v-if="show_score"
							>
								<template slot-scope="scope">
									<div>{{ scope.row["completed_score_%"] }}%</div>
								</template>
							</el-table-column>
							<el-table-column
								v-if="show_score"
								sortable
								prop="completed_total_score"
								label="Total Points"
							>
							</el-table-column>
							<el-table-column
								v-if="show_score"
								sortable
								prop="completed_current_score"
								label="Points Achieved"
							>
							</el-table-column>
							<!-- <el-table-column
								v-if="show_score"
								sortable
								prop="completed_score_%"
								label="Average Score %"
							>
								<template slot-scope="scope">
									<div>{{ scope.row["completed_score_%"] }}%</div>
								</template>
							</el-table-column> -->
						</el-table>
					</el-col>
				</el-row>
				<el-row
					v-if="report_type == 'Consolidated Report'"
					:gutter="10"
					class="mt-3"
				>
					<el-col :span="8" class="text-left">
						<div>
							<b>Showing</b> {{ startNumber }} to {{ endNumber }} of
							{{ filteredreportsTable.length }} results
						</div>
					</el-col>
					<el-col :span="8" class="text-center">
						<el-select
							v-model="perPage"
							name="per_page"
							placeholder="select per page"
							style="width: 90px !important"
							size="mini"
						>
							<el-option label="10" :value="10"></el-option>
							<el-option label="25" :value="25"></el-option>
							<el-option label="50" :value="50"></el-option>
							<el-option label="100" :value="100"></el-option>
						</el-select>
						&nbsp;<b>per page</b>
					</el-col>
					<el-col :span="8" class="text-right">
						<el-pagination
							background
							layout="prev, pager, next"
							:total="filteredreportsTable.length"
							:page-size="perPage"
							:current-page.sync="currentPage"
						></el-pagination>
					</el-col>
				</el-row>
				<el-row
					v-if="report_type != 'Consolidated Report'"
					v-loading="isloading"
					class="reports-table1"
					style="margin-top: 14px"
				>
					<el-col :span="24">
						<el-table
							style="text-transform: capitalize; word-break: break-word"
							height="500"
							:data="
								filteredreportsTableP_T
									.filter(
										(el) =>
											!selected_Location.length ||
											selected_Location.includes(el.store_name)
									)
									.filter(
										(el) =>
											!selected_EmpId.length ||
											selected_EmpId.includes(el.emp_id)
									)
									.filter(
										(el) =>
											!selected_Employee.length ||
											selected_Employee.includes(el.name)
									)
									.filter(
										(el) =>
											!selected_Designation.length ||
											selected_Designation.includes(el.designation)
									)
									.filter(
										(el) =>
											!selected_Region.length ||
											selected_Region.includes(el.region)
									)
									.filter(
										(el) =>
											!selected_SubRegion.length ||
											selected_SubRegion.includes(el.subregion)
									)

									.filter(
										(el) =>
											!search ||
											el.store_name.toLowerCase().includes(search.toLowerCase())
									)
									.filter(
										(el, index) => index >= startNumber - 1 && index < endNumber
									)
							"
						>
							<el-table-column
								fixed
								width="160px"
								sortable
								prop="store_id"
								label="Location Id"
								style="word-break: break-word"
							>
							</el-table-column>
							<el-table-column fixed width="160px" label="Location">
								<template slot="header" slot-scope="scope">
									Location
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_Location"
											size="mini"
											:placeholder="`Search ${
												view_by == 'Location' ? 'Location' : 'User'
											}`"
										></el-input>
										<div
											style="
												max-height: 200px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group v-model="selected_Location">
												<el-checkbox
													v-for="(
														formItem, index
													) in uniqueLocationNames.filter(
														(el) =>
															!searched_Location ||
															el
																.toLowerCase()
																.includes(searched_Location.toLowerCase())
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formItem"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selected_Location = [...uniqueLocationNames]"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_Location = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_Location.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
								<template slot-scope="scope">
									<div
										style="text-transform: capitalize; word-break: break-word"
									>
										{{
											scope.row.store_name != undefined
												? scope.row.store_name
												: "-"
										}}
									</div>
								</template>
							</el-table-column>
							<el-table-column
								width="160px"
								sortable
								prop="project_start_date"
								label="Start Date"
								style="word-break: break-word"
							>
								<template slot-scope="scope">
									<div style="word-break: break-word">
										{{
											scope.row.project_start_date != 0
												? moment(scope.row.project_start_date).format(
														"Do MMM YYYY"
												  )
												: "-"
										}}
									</div>
								</template>
							</el-table-column>
							<el-table-column
								width="160px"
								sortable
								prop="project_end_date"
								label="End Date"
								style="word-break: break-word"
							>
								<template slot-scope="scope">
									<div style="word-break: break-word">
										{{
											scope.row.project_end_date != 0
												? moment(scope.row.project_end_date).format(
														"Do MMM YYYY"
												  )
												: "-"
										}}
									</div>
								</template>
							</el-table-column>
							<el-table-column
								width="190px"
								sortable
								prop="project_completion_date"
								label="Completion Date"
								style="word-break: break-word"
							>
								<template slot-scope="scope">
									<div style="word-break: break-word">
										{{
											scope.row.project_completion_date != 0
												? moment
														.utc(scope.row.project_completion_date)
														.local()
														.format("Do MMM YYYY")
												: "-"
										}}
									</div>
								</template>
							</el-table-column>
							<el-table-column
								width="160px"
								prop="emp_id"
								label="Employee id"
								style="word-break: break-word"
							>
								<template slot="header" slot-scope="scope">
									Employee Id
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_EmpId"
											size="mini"
											placeholder="Search Employee Id"
										></el-input>
										<div
											style="
												max-height: 200px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group v-model="selected_EmpId">
												<el-checkbox
													v-for="(formItem, index) in uniqueEmpId.filter(
														(el) =>
															!searched_EmpId ||
															el
																.toString()
																.toLowerCase()
																.includes(
																	searched_EmpId.toString().toLowerCase()
																)
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formItem"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selected_EmpId = [...uniqueEmpId]"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_EmpId = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_EmpId.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
								<template slot-scope="scope">
									<div style="word-break: break-word">
										{{
											scope.row.emp_id != 0
												? scope.row.emp_id
												: scope.row.emp_id != undefined
												? scope.row.emp_id
												: "-"
										}}
									</div>
								</template>
							</el-table-column>
							<el-table-column
								width="160px"
								prop="name"
								label="Employee"
								style="word-break: break-word"
							>
								<template slot="header" slot-scope="scope">
									Employee
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_Employee"
											size="mini"
											placeholder="Search Employee"
										></el-input>
										<div
											style="
												max-height: 200px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group v-model="selected_Employee">
												<el-checkbox
													v-for="(formItem, index) in uniqueEmployee.filter(
														(el) =>
															!searched_Employee ||
															el
																.toLowerCase()
																.includes(searched_Employee.toLowerCase())
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formItem"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selected_Employee = [...uniqueEmployee]"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_Employee = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_Employee.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
								<template slot-scope="scope">
									<div style="word-break: break-word">
										{{ scope.row.name != 0 ? scope.row.name : "-" }}
									</div>
								</template>
							</el-table-column>
							<el-table-column
								width="160px"
								prop="designation"
								label="Designation"
								style="word-break: break-word"
							>
								<template slot="header" slot-scope="scope">
									Designation
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_Designation"
											size="mini"
											placeholder="Search Employee"
										></el-input>
										<div
											style="
												max-height: 200px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group v-model="selected_Designation">
												<el-checkbox
													v-for="(formItem, index) in uniqueDesignation.filter(
														(el) =>
															!searched_Designation ||
															el
																.toLowerCase()
																.includes(searched_Designation.toLowerCase())
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formItem"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selected_Designation = [...uniqueDesignation]"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_Designation = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_Designation.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
								<template slot-scope="scope">
									<div style="word-break: break-word">
										{{
											scope.row.designation != 0 ? scope.row.designation : "-"
										}}
									</div>
								</template>
							</el-table-column>
							<el-table-column
								width="160px"
								prop="region"
								label="Region"
								style="word-break: break-word"
							>
								<template slot="header" slot-scope="scope">
									Region
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_Region"
											size="mini"
											placeholder="Search Employee"
										></el-input>
										<div
											style="
												max-height: 200px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group v-model="selected_Region">
												<el-checkbox
													v-for="(formItem, index) in uniqueRegion.filter(
														(el) =>
															!searched_Region ||
															el
																.toLowerCase()
																.includes(searched_Region.toLowerCase())
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formItem"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selected_Region = [...uniqueRegion]"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_Region = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_Region.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
							</el-table-column>
							<el-table-column
								width="160px"
								prop="subregion"
								label="Sub Region"
								style="word-break: break-word"
							>
								<template slot="header" slot-scope="scope">
									Sub Region
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_SubRegion"
											size="mini"
											placeholder="Search Employee"
										></el-input>
										<div
											style="
												max-height: 200px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group v-model="selected_SubRegion">
												<el-checkbox
													v-for="(formItem, index) in uniqueSubRegion.filter(
														(el) =>
															!searched_SubRegion ||
															el
																.toLowerCase()
																.includes(searched_SubRegion.toLowerCase())
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formItem"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selected_SubRegion = [...uniqueSubRegion]"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_SubRegion = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_SubRegion.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
							</el-table-column>
							<el-table-column
								prop="total_score"
								width="190px"
								style="word-break: break-word"
								v-if="show_score"
							>
								<template slot="header" slot-scope="scope">
									Points Available
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_Pscore_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											v-on:click="
												last_Pcompletion_order = '';
												last_status_order = '';
												last_Pscore_completion_order = '';
												last_Ppoints_achieved_order = '';
												last_Ppoints_available_order = '';
												last_Pscore_order = 'asc';
											"
										></i>
										<i
											v-if="
												last_Pscore_order == '' || last_Pscore_order == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											v-on:click="
												last_Pcompletion_order = '';
												last_status_order = '';
												last_Pscore_completion_order = '';
												last_Ppoints_achieved_order = '';
												last_Ppoints_available_order = '';
												last_Pscore_order = 'desc';
											"
										></i>
									</span>
								</template>
							</el-table-column>
							<el-table-column
								v-if="show_score"
								prop="current_score"
								width="190px"
								style="word-break: break-word"
							>
								<template slot="header" slot-scope="scope">
									Points Achieved
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_Ppoints_achieved_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											v-on:click="
												last_Pcompletion_order = '';
												last_status_order = '';
												last_Pscore_completion_order = '';
												last_Ppoints_achieved_order = 'asc';
												last_Pscore_order = '';
												last_Ppoints_available_order = '';
											"
										></i>
										<i
											v-if="
												last_Ppoints_achieved_order == '' ||
												last_Ppoints_achieved_order == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											v-on:click="
												last_Pcompletion_order = '';
												last_status_order = '';
												last_Pscore_completion_order = '';
												last_Ppoints_achieved_order = 'desc';
												last_Pscore_order = '';
												last_Ppoints_available_order = '';
											"
										></i>
									</span>
								</template>
							</el-table-column>
							<el-table-column
								v-if="show_score"
								prop="score_completion_%"
								width="160px"
							>
								<template slot="header" slot-scope="scope">
									Score %
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_Pscore_completion_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											v-on:click="
												last_Pcompletion_order = '';
												last_status_order = '';
												last_Pscore_completion_order = 'asc';
												last_Ppoints_available_order = '';
												last_Pscore_order = '';
												last_Ppoints_achieved_order = '';
											"
										></i>
										<i
											v-if="
												last_Pscore_completion_order == '' ||
												last_Pscore_completion_order == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											v-on:click="
												last_Pcompletion_order = '';
												last_status_order = '';
												last_Pscore_completion_order = 'desc';
												last_Ppoints_available_order = '';
												last_Pscore_order = '';
												last_Ppoints_achieved_order = '';
											"
										></i>
									</span>
								</template>
								<template slot-scope="scope">
									<div>{{ scope.row["score_completion_%"] }}%</div>
								</template>
							</el-table-column>
							<el-table-column
								v-if="show_completion"
								width="160px"
								prop="forms_completion_%"
							>
								<template slot="header" slot-scope="scope">
									Completion %
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_Pcompletion_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											v-on:click="
												last_Pcompletion_order = 'asc';
												last_status_order = '';
												last_Pscore_completion_order = '';
												last_Ppoints_achieved_order = '';
												last_Pscore_order = '';
												last_Ppoints_available_order = '';
											"
										></i>
										<i
											v-if="
												last_Pcompletion_order == '' ||
												last_Pcompletion_order == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											v-on:click="
												last_Pcompletion_order = 'desc';
												last_status_order = '';
												last_Pscore_completion_order = '';
												last_Ppoints_achieved_order = '';
												last_Pscore_order = '';
												last_Ppoints_available_order = '';
											"
										></i>
									</span>
								</template>
								<template slot-scope="scope">
									<div>{{ scope.row["forms_completion_%"] }}%</div>
								</template>
							</el-table-column>
							<el-table-column width="160px" prop="status">
								<template slot="header" slot-scope="scope">
									Status
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_status_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											v-on:click="
												last_status_order = 'asc';
												last_Pcompletion_order = '';
												last_Pscore_completion_order = '';
												last_Ppoints_available_order = '';
												last_Pscore_order = '';
												last_Ppoints_achieved_order = '';
											"
										></i>
										<i
											v-if="
												last_status_order == '' || last_status_order == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											v-on:click="
												last_status_order = 'desc';
												last_Pcompletion_order = '';
												last_Pscore_completion_order = '';
												last_Ppoints_available_order = '';
												last_Pscore_order = '';
												last_Ppoints_achieved_order = '';
											"
										></i>
									</span>
								</template>
								<template slot-scope="scope">
									<el-tag
										size="small"
										style="border-radius: 12px; width: 80px; text-align: center"
										:style="
											scope.row.status != 'inprogress'
												? 'border-color:#41BE62; background-color:#FFF9F4; color:#41BE62'
												: 'border-color:#D0342C; background-color:#FFF9F4; color:#D0342C'
										"
										>{{
											scope.row.status != "inprogress"
												? "Completed"
												: "Incomplete"
										}}
									</el-tag>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row
					v-if="report_type != 'Consolidated Report'"
					:gutter="10"
					class="mt-3"
				>
					<el-col :span="8" class="text-left">
						<div>
							<b>Showing</b> {{ startNumber }} to {{ endNumber }} of
							{{ reportsTable1.length }} results
						</div>
					</el-col>
					<el-col :span="8" class="text-center">
						<el-select
							v-model="perPage"
							name="per_page"
							placeholder="select per page"
							style="width: 90px !important"
							size="mini"
						>
							<el-option label="10" :value="10"></el-option>
							<el-option label="25" :value="25"></el-option>
							<el-option label="50" :value="50"></el-option>
							<el-option label="100" :value="100"></el-option>
						</el-select>
						&nbsp;<b>per page</b>
					</el-col>
					<el-col :span="8" class="text-right">
						<el-pagination
							background
							layout="prev, pager, next"
							:total="reportsTable1.length"
							:page-size="perPage"
							:current-page.sync="currentPage"
						></el-pagination>
					</el-col>
				</el-row>
			</div>
			<div
				v-if="view_month_table"
				style="margin-top: 20px; background: white; padding: 5px"
			>
				<el-row>
					<el-col :span="15">
						<span style="font-weight: bold">
							Reports -
							{{
								project_tasksItems.length != 0
									? project_tasksItems.filter((el) =>
											el.id.includes(project_tasks)
									  )[0].name
									: "-"
							}}
							<br />
							( {{ moment(from_date).format("Do MMM YYYY") }} -
							{{ moment(to_date).format("Do MMM YYYY") }} )</span
						>
					</el-col>

					<el-col :span="5" style="margin-left: 20px">
						<input
							type="text"
							v-model="search"
							:placeholder="`Search ${
								view_by == 'Location' ? 'Location' : 'User'
							}`"
							class="searchicon"
						/>
					</el-col>
					<el-col :span="5">
						<el-button
							icon="el-icon-download"
							style="margin-top: -20px; margin-left: 20px"
							class="button-class"
							@click="exportToCSV"
						>
							Download Reports
						</el-button>
					</el-col>
				</el-row>
				<div v-if="view_month_table" class="TableWrapper overflow-table">
					<table
						id="groupedTable"
						class="Table StickyTable"
						style="text-transform: capitalize; border-top: none"
					>
						<thead>
							<tr>
								<th class="light-border-bottom equal-text">&nbsp;</th>
								<template v-for="(head, key) in mom_table_data">
									<th
										:class="[
											show_score && show_completion
												? 'dynamic-width'
												: 'dynamic-width2',
										]"
										:key="key"
										:colspan="show_score && show_completion ? 3 : 2"
										class="light-border-bottom equal-text"
									>
										{{
											reports == "quarter_on_quarter"
												? get_qoq_dates(head.date)
												: moment(head.date, "YYYY-MM-DD").format("MMM, YY")
										}}
									</th>
								</template>
							</tr>
							<tr>
								<th
									class="light-border-bottom equal-text"
									style="min-width: 250px !important"
								>
									{{ view_by == "Location" ? "Location" : "User" }}
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_Location"
											size="mini"
											:placeholder="`Search ${
												view_by == 'Location' ? 'Location' : 'User'
											}`"
										></el-input>
										<div
											style="
												max-height: 200px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group v-model="selected_Location">
												<el-checkbox
													v-for="(
														formItem, index
													) in uniqueLocationNamesMoM.filter(
														(el) =>
															!searched_Location ||
															el
																.toLowerCase()
																.includes(searched_Location.toLowerCase())
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formItem"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selected_Location = [...uniqueLocationNamesMoM]"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_Location = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_Location.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</th>
								<template v-for="(head, key_2) in mom_table_data">
									<th
										:key="key_2 + '-occ' + head.last_occurance_order"
										class="light-border-bottom equal-text dynamic-widthh1"
									>
										Total Projects
										<span slot="reference" class="cursor-pointer">
											<i
												v-if="head.last_occurance_order == 'desc'"
												class="el-icon-caret-top"
												style="font-size: 12px"
												@click="
													filter_by_last_occurance_order(
														head,
														mom_table_data,
														'desc',
														'Occ',
														key_2
													)
												"
											></i>
											<i
												v-if="
													head.last_occurance_order == '' ||
													head.last_occurance_order == 'asc'
												"
												class="el-icon-caret-bottom"
												style="font-size: 12px"
												@click="
													filter_by_last_occurance_order(
														head,
														mom_table_data,
														'asc',
														'Occ',
														key_2
													)
												"
											></i>
										</span>
									</th>
									<th
										v-if="show_completion"
										:key="key_2 + '-comp' + head.last_completion_order"
										class="light-border-bottom equal-text dynamic-widthh2"
										:class="
											!show_score
												? { 'vertical-divider': showVerticalDivider }
												: ''
										"
									>
										Completion %
										<span slot="reference" class="cursor-pointer">
											<i
												v-if="head.last_completion_order == 'desc'"
												class="el-icon-caret-top"
												style="font-size: 12px"
												@click="
													filter_by_last_occurance_order(
														head,
														mom_table_data,
														'desc',
														'Com',
														key_2
													)
												"
											></i>
											<i
												v-if="
													head.last_completion_order == '' ||
													head.last_completion_order == 'asc'
												"
												class="el-icon-caret-bottom"
												style="font-size: 12px"
												@click="
													filter_by_last_occurance_order(
														head,
														mom_table_data,
														'asc',
														'Com',
														key_2
													)
												"
											></i>
										</span>
									</th>
									<th
										v-if="show_score"
										:key="key_2 + '-score' + head.last_score_order"
										class="light-border-bottom equal-text dynamic-widthh3"
										:class="{ 'vertical-divider': showVerticalDivider }"
									>
										Score %
										<span slot="reference" class="cursor-pointer">
											<i
												v-if="head.last_score_order == 'desc'"
												class="el-icon-caret-top"
												style="font-size: 12px"
												@click="
													filter_by_last_occurance_order(
														head,
														mom_table_data,
														'desc',
														'Sco',
														key_2
													)
												"
											></i>
											<i
												v-if="
													head.last_score_order == '' ||
													head.last_score_order == 'asc'
												"
												class="el-icon-caret-bottom"
												style="font-size: 12px"
												@click="
													filter_by_last_occurance_order(
														head,
														mom_table_data,
														'asc',
														'Sco',
														key_2
													)
												"
											></i>
										</span>
									</th>
								</template>
							</tr>
							<tr>
								<th
									class="light-border-bottom equal-text"
									style="min-width: 250px !important"
								>
									<div
										:style="
											selectedLocationType == 'region'
												? 'text-decoration: underline;cursor: pointer'
												: ''
										"
										@click="
											view_by == 'Location' && selectedLocationType == 'region'
												? open_report_dashboard(null, null, 'TOTAL')
												: ''
										"
									>
										India
									</div>
								</th>
								<template v-for="(head, key_2) in mom_table_data">
									<th
										:key="key_2 + '-occ' + head.last_occurance_order"
										class="light-border-bottom equal-text dynamic-widthh1"
									>
										{{ get_total_mom_qoq_data(head, key_2, "total") }}
									</th>
									<th
										v-if="show_completion"
										:key="key_2 + '-comp' + head.last_completion_order"
										class="light-border-bottom equal-text dynamic-widthh2"
										:class="
											!show_score
												? { 'vertical-divider': showVerticalDivider }
												: ''
										"
									>
										{{ get_total_mom_qoq_data(head, key_2, "completion_%") }}
										%
									</th>
									<th
										v-if="show_score"
										:key="key_2 + '-score' + head.last_score_order"
										class="light-border-bottom equal-text dynamic-widthh3"
										:class="{ 'vertical-divider': showVerticalDivider }"
									>
										{{
											get_total_mom_qoq_data(head, key_2, "completed_score_%")
										}}
										%
									</th>
								</template>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(item, key_3) in computedAllLocationsList.filter(
									(el, index) =>
										index >= startNumberMOM - 1 && index < endNumberMOM
								)"
								:key="key_3 + '-tbl-row'"
							>
								<td
									class="light-border-bottom equal-text"
									@click="view_by == 'Location' ? get_table_data_row(item) : ''"
								>
									<div
										:style="
											view_by == 'Location'
												? `text-transform: capitalize;
											margin-top: -5px;
											color: #d26300;
											cursor: pointer;
											word-break: break-word;`
												: `text-transform: capitalize;
											margin-top: -5px;
											word-break: break-word;`
										"
									>
										{{ item.name }}
									</div>
								</td>
								<template v-for="(item_data, key_4) in mom_table_data">
									<td
										:key="key_4 + '-occ'"
										class="light-border-bottom equal-text"
										style="text-align: center !important"
									>
										{{ getMomTblData(item.name, item_data, "total") }}
									</td>
									<td
										v-if="show_completion"
										:key="key_4 + '-comp'"
										class="light-border-bottom equal-text"
										style="text-align: center !important"
									>
										{{ getMomTblData(item.name, item_data, "completion_%") }}%
									</td>
									<td
										v-if="show_score"
										:key="key_4 + '-sco'"
										class="light-border-bottom equal-text"
										style="text-align: center !important"
									>
										{{
											getMomTblData(item.name, item_data, "completed_score_%")
										}}%
									</td>
								</template>
							</tr>
						</tbody>
					</table>
				</div>

				<el-row v-if="view_month_table" :gutter="10" class="mt-3">
					<el-col :span="8" class="text-left">
						<div>
							<b>Showing</b> {{ startNumberMOM }} to {{ endNumberMOM }} of
							{{ computedAllLocationsList.length }} results
						</div>
					</el-col>
					<el-col :span="8" class="text-center">
						<el-select
							v-model="perPage"
							name="per_page"
							placeholder="select per page"
							style="width: 90px !important"
							size="mini"
						>
							<el-option label="10" :value="10"></el-option>
							<el-option label="25" :value="25"></el-option>
							<el-option label="50" :value="50"></el-option>
							<el-option label="100" :value="100"></el-option>
						</el-select>
						&nbsp;<b>per page</b>
					</el-col>
					<el-col :span="8" class="text-right">
						<el-pagination
							background
							layout="prev, pager, next"
							:total="computedAllLocationsList.length"
							:page-size="perPage"
							:current-page.sync="currentPage"
						></el-pagination>
					</el-col>
				</el-row>
			</div>

			<!-- <el-table v-if="view_month_table" :data="all_location_list" class="ns-table"> 
	    <el-table-column
	      label="Location"
	      class="light-border-bottom equal-text"
	      prop="name"
	    ></el-table-column>
	    <el-table-column
	      v-for="(head, key_2) in mom_table_data"
	      :key="key_2"
	      :label="head.date"
	    >
	      <el-table-column
	        :label="`Occurrence`"
	        class="light-border-bottom equal-text"
	        prop="arr"
	        :formatter="formatOccurrenceWithParams(head.date)"
	      ></el-table-column>
	      <el-table-column
	        :label="`Completion`"
	        class="light-border-bottom equal-text"
	        prop="arr"
	        :formatter="formatCompletionWithParams(head.date)"
	      ></el-table-column>
	    </el-table-column>
	  </el-table> -->

			<!-- </div> -->
		</div>
		<div v-if="current_view == 'Page_2'">
			<ReportDashboardVue
				:storeObj="storeObj"
				@clicked="get_dashboard_response"
				:current_view="current_view"
				:from_date="from_date"
				:to_date="to_date"
				:project_tasksItems="project_tasksItems"
				:project_tasks="project_tasks"
				:view_by="view_by"
			/>
		</div>
		<div v-if="current_view == 'Page_3'">
			<ReportsDashboardMoM_QoQVue
				:storeObj="storeObj"
				@clicked="get_dashboard_response_MoMQoQ"
				:current_view="current_view"
				:from_date="from_date"
				:to_date="to_date"
				:project_tasksItems="project_tasksItems"
				:project_tasks="project_tasks"
				:view_by="view_by"
				:show_fields="show_fields"
				:is_outlet="is_outlet"
			/>
		</div>
		<DetailedReportPopupVue
			:DialogDetailedReport="DialogDetailedReport"
			:all_locations="all_locations"
			:project_tasks="project_tasks"
			:project_tasksItems="project_tasksItems"
			@close="get_detailed_report_actions"
			@closed="get_detailed_report_actions"
			:locations="locations"
			:from_date="from_date"
			:to_date="to_date"
		/>
	</div>
</template>

<script>
import PerformanceGraphVue from "./PerformanceGraph.vue";
import PerformanceGraphNonMonthVue from "./PerformanceGraphNonMonth.vue";
import ReportDashboardVue from "./ReportDashboard.vue";
import formBuilderServices from "../../../../services/formBuilderServices";
import exportFromJSON from "export-from-json";
import { mapState, mapActions } from "vuex";
import TaskSkeletonLoader from "../../labourPlaninig/tasks/taskSkeletonLoader.vue";
import DetailedReportPopupVue from "./DetailedReportPopup.vue";
import ReportsDashboardMoM_QoQVue from "./ReportsDashboardMoM_QoQ.vue";
var moment = require("moment");
export default {
	props: {
		show_tabs_upper: Boolean,
	},
	components: {
		PerformanceGraphVue,
		ReportDashboardVue,
		TaskSkeletonLoader,
		DetailedReportPopupVue,
		PerformanceGraphNonMonthVue,
		ReportsDashboardMoM_QoQVue,
	},
	data: () => ({
		all_location_list: [],
		view_by: "Location",
		view_byItems: [
			{ name: "Location", id: "Location" },
			{ name: "User", id: "User" },
		],
		users: "",
		usersItems: [],
		isDomLoading: true,
		SummaryreportsTable: [],
		is_csv_loading: false,

		current_view: "Page_1",
		completion_rate: "53%",
		actions: 7,
		overdue: 7,
		due_today: 43,
		total_active: 100,
		summaryData: {},
		moment: moment,
		locationItems: [],
		locations: [],
		reportItems: [
			// { name: "Week To Date", id: "week_to_date" },
			// { name: "Month To Date", id: "month_to_date" },
			// { name: "Year To Date", id: "year_to_date" },
			// { name: "Custom Date", id: "custom_date" },
			// { name: "Month On Month", id: "month_on_month" },
			// { name: "Quarter On Quarter", id: "quarter_on_quarter" },
		],
		reports: "week_to_date",
		from_date: "",
		to_date: "",
		project_tasks: "",
		project_tasksItems: [],
		category: "All",
		categoryItems: [],
		forms: "All",
		formItems: [],
		selectType: "score",
		selectTypeItems: [
			{ name: "Score %", id: "score" },
			{ name: "Completion %", id: "completion" },
		],
		search: "",
		dataList: [],
		reportsTable: [],
		reportsTable1: [],

		currentPage: 1,
		perPage: 10,
		selected_Location: [],
		selected_EmpId: [],
		selected_Employee: [],
		selected_Region: [],
		selected_SubRegion: [],

		selected_Designation: [],

		searched_Location: "",
		searched_EmpId: "",
		searched_Employee: "",
		searched_Region: "",
		searched_SubRegion: "",

		searched_Designation: "",

		isloading: false,
		storeObj: {},
		labels: [],
		CountryAverege: [],
		show_report: false,
		locationType: "Hierarchy",
		visible: false,
		report_type: "Consolidated Report",
		lastAuditConductedList: [],
		last_occurance_order: "",
		last_completed_order: "",
		last_completion_order: "",
		last_points_achieved_oeder: "",
		last_average_score_order: "",
		last_total_points_order: "",
		last_score_order: "",
		selectedLocationType: "location",
		all_locations: [],
		DialogDetailedReport: false,
		last_status_order: "",
		last_Pcompletion_order: "",
		last_Pscore_completion_order: "",
		last_Ppoints_achieved_order: "",
		last_Ppoints_available_order: "",
		last_Pscore_order: "",
		view_month_table: false,
		groupedData: {},
		groupedDates: [],
		mom_table_data: [],
		count_tabkle: 0,
		filter_by: {
			item: null,
			arr: [],
			type: null,
			type2: null,
			key: null,
		},
		show_fields: [],
		show_score: false,
		show_completion: false,
		is_outlet: false,
		showVerticalDivider: true,
		
	}),
	computed: {
		averageCompletionPercentages() {
			const averages = [];
			this.mom_table_data.forEach((date) => {
				const completionPercentages = date.arr.map(
					(entry) => entry["completion_%"]
				);
				const average =
					completionPercentages.reduce(
						(total, percentage) => total + percentage,
						0
					) / completionPercentages.length;
				averages.push(average.toFixed(2));
			});
			return averages;
		},
		filteredreportsTable22() {
			// Convert groupedData object to an array of objects
			return Object.entries(this.groupedData).map(([date, group]) => ({
				[date]: group.objects.reduce((acc, obj) => ({ ...acc, ...obj }), {}),
			}));
		},
		computedAllLocationsList() {
			let result = [...this.all_location_list];
			if (this.selected_Location.length) {
				result = result.filter((el) =>
					this.selected_Location.includes(el.name)
				);
			}
			if (this.search.length) {
				result = result.filter((el) =>
					el.name.toLowerCase().includes(this.search.toLowerCase())
				);
			}
			this.show_report = false;
			setTimeout(() => {
				this.show_report = true;
			}, 100);
			return result;
		},
		filteredreportsTableP_T() {
			let arr1 = [...this.reportsTable1];
			if (this.last_status_order) {
				if (this.last_status_order.toString().toLowerCase() == "asc") {
					arr1 = arr1.sort((a, b) => a["status"].localeCompare(b["status"]));
				}
				if (this.last_status_order.toString().toLowerCase() == "desc") {
					arr1 = arr1.sort((a, b) => b["status"].localeCompare(a["status"]));
				}
			}
			if (this.last_Pcompletion_order) {
				if (this.last_Pcompletion_order.toString().toLowerCase() == "asc") {
					arr1 = arr1.sort(
						(a, b) => a["forms_completion_%"] - b["forms_completion_%"]
					);
				}
				if (this.last_Pcompletion_order.toString().toLowerCase() == "desc") {
					arr1 = arr1.sort(
						(a, b) => b["forms_completion_%"] - a["forms_completion_%"]
					);
				}
			}
			if (this.last_Pscore_completion_order) {
				if (
					this.last_Pscore_completion_order.toString().toLowerCase() == "asc"
				) {
					arr1 = arr1.sort(
						(a, b) => a["score_completion_%"] - b["score_completion_%"]
					);
				}
				if (
					this.last_Pscore_completion_order.toString().toLowerCase() == "desc"
				) {
					arr1 = arr1.sort(
						(a, b) => b["score_completion_%"] - a["score_completion_%"]
					);
				}
			}
			if (this.last_Pscore_order) {
				if (this.last_Pscore_order.toString().toLowerCase() == "asc") {
					arr1 = arr1.sort((a, b) => a["total_score"] - b["total_score"]);
				}
				if (this.last_Pscore_order.toString().toLowerCase() == "desc") {
					arr1 = arr1.sort((a, b) => b["total_score"] - a["total_score"]);
				}
			}

			if (this.last_Ppoints_achieved_order) {
				if (
					this.last_Ppoints_achieved_order.toString().toLowerCase() == "asc"
				) {
					arr1 = arr1.sort((a, b) => a["current_score"] - b["current_score"]);
				}
				if (
					this.last_Ppoints_achieved_order.toString().toLowerCase() == "desc"
				) {
					arr1 = arr1.sort((a, b) => b["current_score"] - a["current_score"]);
				}
			}
			if (this.last_Ppoints_available_order) {
				if (
					this.last_Ppoints_available_order.toString().toLowerCase() == "asc"
				) {
					arr1 = arr1.sort(
						(a, b) => a["completed_total_score"] - b["completed_total_score"]
					);
				}
				if (
					this.last_Ppoints_available_order.toString().toLowerCase() == "desc"
				) {
					arr1 = arr1.sort(
						(a, b) => b["completed_total_score"] - a["completed_total_score"]
					);
				}
			}
			this.show_report = false;
			this.reportsTable1 = arr1;
			this.dataList = [];
			this.labels = [];
			for (let i = 0; i < arr1.length; i++) {
				arr1[i].location_name = arr1[i].store_name;
			}
			let dataList = arr1;
			arr1 = arr1.filter((el) => el.location_name != 0);
			arr1 = arr1.filter((el) => el.location_name != undefined);
			let labels = arr1.map(
				(el) =>
					el.location_name.charAt(0).toUpperCase() + el.location_name.slice(1)
			);
			this.dataList = dataList;
			this.labels = labels;
			setTimeout(() => {
				this.show_report = true;
			}, 100);
			this.$forceUpdate();
			return arr1;
		},
		filteredreportsTable() {
			let array1 = [...this.reportsTable];
			if (this.last_occurance_order) {
				if (this.last_occurance_order.toString().toLowerCase() == "asc") {
					array1 = array1.sort((a, b) => a.total - b.total);
				}
				if (this.last_occurance_order.toString().toLowerCase() == "desc") {
					array1 = array1.sort((a, b) => b.total - a.total);
				}
			}
			if (this.last_completed_order) {
				if (this.last_completed_order.toString().toLowerCase() == "asc") {
					array1 = array1.sort((a, b) => a.completed - b.completed);
				}
				if (this.last_completed_order.toString().toLowerCase() == "desc") {
					array1 = array1.sort((a, b) => b.completed - a.completed);
				}
			}
			if (this.last_completion_order) {
				if (this.last_completion_order.toString().toLowerCase() == "asc") {
					array1 = array1.sort((a, b) => a["completion_%"] - b["completion_%"]);
				}
				if (this.last_completion_order.toString().toLowerCase() == "desc") {
					array1 = array1.sort((a, b) => b["completion_%"] - a["completion_%"]);
				}
			}
			if (this.last_score_order) {
				if (this.last_score_order.toString().toLowerCase() == "asc") {
					array1 = array1.sort(
						(a, b) => a["completed_score_%"] - b["completed_score_%"]
					);
				}
				if (this.last_score_order.toString().toLowerCase() == "desc") {
					array1 = array1.sort(
						(a, b) => b["completed_score_%"] - a["completed_score_%"]
					);
				}
			}
			if (this.last_total_points_order) {
				if (this.last_total_points_order.toString().toLowerCase() == "asc") {
					array1 = array1.sort(
						(a, b) => a["completed_total_score"] - b["completed_total_score"]
					);
				}
				if (this.last_total_points_order.toString().toLowerCase() == "desc") {
					array1 = array1.sort(
						(a, b) => b["completed_total_score"] - a["completed_total_score"]
					);
				}
			}
			if (this.last_points_achieved_oeder) {
				if (this.last_points_achieved_oeder.toString().toLowerCase() == "asc") {
					array1 = array1.sort(
						(a, b) =>
							a["completed_current_score"] - b["completed_current_score"]
					);
				}
				if (
					this.last_points_achieved_oeder.toString().toLowerCase() == "desc"
				) {
					array1 = array1.sort(
						(a, b) =>
							b["completed_current_score"] - a["completed_current_score"]
					);
				}
			}
			if (this.last_average_score_order) {
				if (this.last_average_score_order.toString().toLowerCase() == "asc") {
					array1 = array1.sort(
						(a, b) => a["completed_score_%"] - b["completed_score_%"]
					);
				}
				if (this.last_average_score_order.toString().toLowerCase() == "desc") {
					array1 = array1.sort(
						(a, b) => b["completed_score_%"] - a["completed_score_%"]
					);
				}
			}
			this.show_report = false;
			this.reportsTable = array1;
			this.dataList = [];
			this.labels = [];
			for (let i = 0; i < array1.length; i++) {
				array1[i].location_name = array1[i].name;
			}
			let dataList = array1;
			let labels = array1.map(
				(el) =>
					el.location_name.charAt(0).toUpperCase() + el.location_name.slice(1)
			);
			this.dataList = dataList;
			this.labels = labels;
			setTimeout(() => {
				this.show_report = true;
			}, 100);
			this.$forceUpdate();
			return array1;
		},
		startNumberMOM() {
			let start = this.currentPage * this.perPage - (this.perPage - 1);
			return start;
		},
		startNumber() {
			let start = this.currentPage * this.perPage - (this.perPage - 1);
			return start;
		},
		endNumberMOM() {
			let end = Math.min(
				this.startNumberMOM + this.perPage - 1,
				this.computedAllLocationsList.length
			);
			return end;
		},
		endNumber() {
			let end = Math.min(
				this.startNumber + this.perPage - 1,
				this.report_type == "Consolidated Report"
					? this.reportsTable.length
					: this.reportsTable1.length
			);
			return end;
		},
		uniqueLocationNames() {
			if (this.report_type == "Consolidated Report") {
				let arr = [...new Set(this.reportsTable.map((el) => el.name))];
				return arr;
			} else {
				let arr = [...new Set(this.reportsTable1.map((el) => el.store_name))];
				return arr;
			}
		},
		uniqueLocationNamesMoM() {
			let arr = [...new Set(this.all_location_list.map((el) => el.name))];
			return arr;
		},
		uniqueEmpId() {
			let arr = [
				...new Set(
					this.reportsTable1.map((el) =>
						el.emp_id != 0 ? el.emp_id.toString() : ""
					)
				),
			];
			return arr;
		},
		uniqueEmployee() {
			let arr = [
				...new Set(
					this.reportsTable1.map((el) => (el.name != 0 ? el.name : ""))
				),
			];
			return arr;
		},
		uniqueRegion() {
			let arr = [
				...new Set(
					this.reportsTable1.map((el) => (el.region != 0 ? el.region : ""))
				),
			];
			return arr;
		},
		uniqueSubRegion() {
			let arr = [
				...new Set(
					this.reportsTable1.map((el) =>
						el.subregion != 0 ? el.subregion : ""
					)
				),
			];
			return arr;
		},
		uniqueDesignation() {
			let arr = [
				...new Set(
					this.reportsTable1.map((el) =>
						el.designation != 0 ? el.designation : ""
					)
				),
			];
			return arr;
		},
		fromDatePickerOptions() {
			return {
				firstDayOfWeek: 1,
				disabledDate: (date) => {
					if (this.reports == "quarter_on_quarter") {
						const month = new Date(date).getMonth(); // Get the month (0-indexed)
						// Disable all months except January (0), April (3), July (6), and October (9)
						let currentDate = new Date();
						if (date > currentDate) {
							return true;
						} else {
							return ![0, 3, 6, 9].includes(month);
						}
					} else {
						let currentDate = new Date();
						if (date > currentDate) {
							return true;
						}
						// Disable dates less than from_date or greater than to_date
						if (this.from_date) {
							return date < this.from_date;
						}
					}
					// Disable dates greater than the current date

					// If from_date or to_date is not selected, no date is disabled
					return false;
				},
			};
		},
		datePickerOptions() {
			return {
				firstDayOfWeek: 1,
				disabledDate: (date) => {
					if (this.reports == "quarter_on_quarter") {
						const month = new Date(date).getMonth(); // Get the month (0-indexed)
						// Disable all months except January (0), April (3), July (6), and October (9)
						let currentDate = new Date();
						const oneYearAgo = moment(this.to_date)
							.subtract(1, "years")
							.format("YYYY-MM-DD");
						if (moment(date).format("YYYY-MM-DD") < oneYearAgo) {
							return true;
						}
						if (date > currentDate) {
							return true;
						} else {
							return ![0, 3, 6, 9].includes(month);
						}
					}
					if (this.reports == "month_on_month") {
						const oneYearAgo = moment(this.to_date)
							.subtract(1, "years")
							.format("YYYY-MM-DD");
						if (moment(date).format("YYYY-MM-DD") < oneYearAgo) {
							return true;
						}
					}
					return date > moment().subtract(0, "days");
				},
			};
		},
		// datePickerOptions: {
		// 	firstDayOfWeek: 1,
		// 	disabledDate(date) {
		// 		return date > moment().subtract(0, "days");
		// 	},
		// },
	},
	watch: {
		// selectedLocationType() {
		// 	this.listDashboardData();
		// },
		reports(val) {
			switch (val) {
				case "week_to_date":
					this.from_date = moment().isoWeekday(1).format("yyyy-MM-DD");
					this.listDashboardData();
					break;
				case "month_to_date":
					this.from_date = moment().startOf("month").format("yyyy-MM-DD");
					this.listDashboardData();
					break;
				case "year_to_date":
					this.from_date = moment().startOf("year").format("yyyy-MM-DD");
					this.listDashboardData();
					break;
				case "custom_date":
					this.from_date = moment().format("yyyy-MM-DD");
					this.to_date = moment().format("yyyy-MM-DD");
					this.listDashboardData();
					break;
				case "month_on_month":
					this.from_date = moment().startOf("month").format("yyyy-MM-DD");
					this.to_date = moment().format("yyyy-MM-DD");
					this.listDashboardData();
					break;
				case "quarter_on_quarter":
					this.from_date = moment().format("yyyy-MM-DD");
					this.to_date = moment().format("yyyy-MM-DD");
					this.listDashboardData();
					break;
				default:
					break;
			}
		},
	},
	async created() {
		this.from_date = moment().isoWeekday(1).format("yyyy-MM-DD");
		this.to_date = moment().format("yyyy-MM-DD");
		this.listCountries();
		this.listProjectsAndTasks();
	},
	methods: {
		...mapActions("CommonStore", [
			"addDownloadingReportCountAction",
			"removeDownloadingReportCountAction",
		]),
		get_total_mom_qoq_data(item, key, value) {
			let total = 0;
			let count = 0;
			for (let index = 0; index < this.mom_table_data.length; index++) {
				const el = this.mom_table_data[index];
				if (item) {
					if (index === key) {
						for (const obj of el.arr) {
							total += obj[value];
							count++;
						}
						return value == "total" ? total : (total / count).toFixed(2);
					}
				}
			}
		},
		get_qoq_dates(date) {
			let new_date = moment(date, "YYYY-MM-DD").format("MMM, YY");
			if (new_date.toLowerCase().includes("jan")) {
				new_date = `${new_date} - Mar, ${new_date.split(",")[1]}`;
			}
			if (new_date.toLowerCase().includes("apr")) {
				new_date = `${new_date} - Jun, ${new_date.split(",")[1]}`;
			}
			if (new_date.toLowerCase().includes("jul")) {
				new_date = `${new_date} - Sep, ${new_date.split(",")[1]}`;
			}
			if (new_date.toLowerCase().includes("oct")) {
				new_date = `${new_date} - Dec, ${new_date.split(",")[1]}`;
			}
			return new_date;
		},
		exportToCSV() {
			const names = [
				...new Set(
					this.mom_table_data.flatMap((item) =>
						item.arr.map((obj) => obj.name.replaceAll(",", " "))
					)
				),
			];
			const months = [...new Set(this.mom_table_data.map((item) => item.date))];
			const csvContent = [];

			if (this.show_completion && this.show_score) {
				const headerRow = [
					"",
					...months.flatMap((month) => [month, month, month, ""]),
				];
				csvContent.push(headerRow.join(","));
				const subheaderRow = ["name"];
				months.forEach(() => {
					subheaderRow.push("Occurrence", "Completion", "Score", ""); // Add date headers
				});
				csvContent.push(subheaderRow.join(","));
				names.forEach((name) => {
					const rowData = [];
					rowData.push(name); // Add 'name' in the first cell
					months.forEach((month) => {
						const monthData = this.mom_table_data
							.find((item) => item.date === month)
							.arr.find(
								(obj) =>
									obj.name.replaceAll(",", " ") === name.replaceAll(",", " ")
							) || {
							total: undefined,
							"completion_%": undefined,
							"completed_score_%": undefined,
						}; // Only take the first occurrence
						rowData.push(
							monthData ? monthData.total || "" : "",
							monthData ? monthData["completion_%"] || "0" : "0",
							monthData ? monthData["completed_score_%"] || "0" : "0",
							""
						);
					});
					csvContent.push(rowData.join(","));
				});
			} else if (this.show_completion) {
				const headerRow = [
					"",
					...months.flatMap((month) => [month, month, ""]),
				];
				csvContent.push(headerRow.join(","));
				const subheaderRow = ["name"];
				months.forEach(() => {
					subheaderRow.push("Occurrence", "Completion", ""); // Add date headers
				});
				csvContent.push(subheaderRow.join(","));
				// Data rows
				names.forEach((name) => {
					const rowData = [];
					rowData.push(name); // Add 'name' in the first cell
					months.forEach((month) => {
						const monthData = this.mom_table_data
							.find((item) => item.date === month)
							.arr.find(
								(obj) =>
									obj.name.replaceAll(",", " ") === name.replaceAll(",", " ")
							) || { total: undefined, "completion_%": undefined }; // Only take the first occurrence
						rowData.push(
							monthData ? monthData.total || "0" : "0",
							monthData ? monthData["completion_%"] || "0" : "0",
							""
						);
					});
					csvContent.push(rowData.join(","));
				});
			} else if (this.show_score) {
				const headerRow = [
					"",
					...months.flatMap((month) => [month, month, ""]),
				];
				csvContent.push(headerRow.join(","));
				const subheaderRow = ["name"];
				months.forEach(() => {
					subheaderRow.push("Occurrence", "Score", ""); // Add date headers
				});
				csvContent.push(subheaderRow.join(","));
				// Data rows
				names.forEach((name) => {
					const rowData = [];
					rowData.push(name); // Add 'name' in the first cell
					months.forEach((month) => {
						const monthData = this.mom_table_data
							.find((item) => item.date === month)
							.arr.find(
								(obj) =>
									obj.name.replaceAll(",", " ") === name.replaceAll(",", " ")
							) || { total: undefined, "completed_score_%": undefined }; // Only take the first occurrence
						rowData.push(
							monthData ? monthData.total || "0" : "0",
							monthData ? monthData["completed_score_%"] || "0" : "0",
							""
						);
					});
					csvContent.push(rowData.join(","));
				});
			}
			function formatDate(dateString) {
				return moment(dateString).format("MMM YYYY");
			}
			const firstEntryFormatted = formatDate(months[0]);
			const lastEntryFormatted = formatDate(months[months.length - 1]);
			const blob = new Blob([csvContent.join("\n")], {
				type: "text/csv;charset=utf-8;",
			});
			const link = document.createElement("a");
			link.href = URL.createObjectURL(blob);
			link.download = `${
				this.project_tasksItems.filter((el) =>
					el.id.includes(this.project_tasks)
				)[0].name
			}_ ${
				this.reportItems.filter((el) => el.id.includes(this.reports))[0].name
			}_${firstEntryFormatted}-${lastEntryFormatted}`;
			link.click();
		},
		filter_by_last_occurance_order(item, arr, type, type2, key) {
			this.filter_by = {
				item: item,
				arr: arr,
				type: type,
				type2: type2,
				key: key,
			};
			// Instead of calling and watching in computed we can call it here
			for (let index = 0; index < this.mom_table_data.length; index++) {
				const el = this.mom_table_data[index];
				if (item) {
					if (index === key) {
						if (type2 == "Occ") {
							if (type == "asc") {
								el.last_completion_order = "";
								el.last_occurance_order = "desc";
								el.last_score_order = "";
							}
							if (type == "desc") {
								el.last_occurance_order = "asc";
								el.last_completion_order = "";
								el.last_score_order = "";
							}
							if (el.last_occurance_order.toString().toLowerCase() == "asc") {
								el.arr.sort((a, b) => a.total - b.total);
								this.all_location_list = el.arr;
							}
							if (el.last_occurance_order.toString().toLowerCase() == "desc") {
								el.arr.sort((a, b) => b.total - a.total);
								this.all_location_list = el.arr;
							}
						}
						if (type2 == "Com") {
							if (type == "asc") {
								el.last_completion_order = "desc";
								el.last_occurance_order = "";
								el.last_score_order = "";
							}
							if (type == "desc") {
								el.last_occurance_order = "";
								el.last_completion_order = "asc";

								el.last_score_order = "";
							}
							if (el.last_completion_order.toString().toLowerCase() == "asc") {
								el.arr.sort((a, b) => a["completion_%"] - b["completion_%"]);
								this.all_location_list = el.arr;
							}
							if (el.last_completion_order.toString().toLowerCase() == "desc") {
								el.arr.sort((a, b) => b["completion_%"] - a["completion_%"]);
								this.all_location_list = el.arr;
							}
						}
						if (type2 == "Sco") {
							if (type == "asc") {
								el.last_score_order = "desc";
								el.last_completion_order = "";
								el.last_occurance_order = "";
							}
							if (type == "desc") {
								el.last_occurance_order = "";
								el.last_completion_order = "";
								el.last_score_order = "asc";
							}
							if (el.last_score_order.toString().toLowerCase() == "asc") {
								el.arr.sort(
									(a, b) => a["completed_score_%"] - b["completed_score_%"]
								);
								this.all_location_list = el.arr;
							}
							if (el.last_score_order.toString().toLowerCase() == "desc") {
								el.arr.sort(
									(a, b) => b["completed_score_%"] - a["completed_score_%"]
								);
								this.all_location_list = el.arr;
							}
						}
					}
				}
			}
		},
		groupByDates() {
			const groupedArrays = [];
			const groupedByDate = {};
			for (const obj of this.reportsTable) {
				const date = obj.resample_date;
				if (!groupedByDate[date]) {
					groupedByDate[date] = {
						date,
						arr: [],
						last_occurance_order: "",
						last_completion_order: "",
						last_score_order: "",
					};
					groupedArrays.push(groupedByDate[date]);
				}
				groupedByDate[date].arr.push(obj);
			}
			if (groupedArrays.length) {
				groupedArrays[0].arr.forEach((el) => {
					this.all_location_list.push({
						name: el.name,
						basics: el.basics,
						total: el.total,
						completed: el.completed,
						completed_total_score: el.completed_total_score,
						"completed_score_%": el["completed_score_%"],
						"completion_%": el["completion_%"],
					});
				});
			}
			this.all_location_list = [...this.all_location_list].sort((a, b) =>
				a.name.localeCompare(b.name)
			);
			this.mom_table_data = groupedArrays;
			this.mom_table_data.sort((a, b) => {
				const dateA = new Date(a.date.split("-").reverse().join("-"));
				const dateB = new Date(b.date.split("-").reverse().join("-"));
				return dateA - dateB;
			});

			this.view_month_table = true;
			this.isDomLoading = false;
			this.show_report = true;
		},
		getMomTblData(name, item_data, key) {
			const result = item_data.arr.find((e) => e.name === name);
			return result ? result[key] : 0;
		},
		get_vertical_detailed_report() {
			this.addDownloadingReportCountAction("Report");
			let from_date = moment(this.from_date).format("yyyy-MM-DD");
			let to_date = moment(this.to_date).format("yyyy-MM-DD");
			let params = {
				start_date: from_date,
				end_date: to_date,
				project: this.project_tasks,
				filters: {
					outlets: this.locations,
				},
			};
			formBuilderServices
				.getVerticalDetailReport(params)
				.then((response) => {
					var fileURL = window.URL.createObjectURL(new Blob([response.data]));
					var fileLink = document.createElement("a");
					fileLink.href = fileURL;
					fileLink.setAttribute(
						"download",
						`Vertical Detailed Report - ${
							this.project_tasksItems.length != 0
								? this.project_tasksItems.filter((el) =>
										el.id.includes(this.project_tasks)
								  )[0].name
								: "-"
						} - ${params.start_date + "-" + params.end_date + ".xlsx"}`
					); //or any other extension
					document.body.appendChild(fileLink);
					fileLink.click();
					this.removeDownloadingReportCountAction();
				})
				.catch((err) => {
					this.removeDownloadingReportCountAction();
				});
		},
		get_detailed_report_actions() {
			console.log(this.locations, "loc");
			this.report_type = "Consolidated Report";
			this.DialogDetailedReport = false;
			this.listReportsSwitchData();
			this.$forceUpdate();
		},
		get_reports_label(type) {
			if (type == "label")
				return this.SummaryreportsTable[0] != undefined
					? this.SummaryreportsTable[0].name
					: "";
			if (type == "occurance")
				return this.SummaryreportsTable[0] != undefined
					? this.SummaryreportsTable[0].total
					: "";
			if (type == "completed")
				return this.SummaryreportsTable[0] != undefined
					? this.SummaryreportsTable[0].completed
					: "";
			if (type == "completion")
				return this.SummaryreportsTable[0] != undefined
					? this.SummaryreportsTable[0]["completion_%"] + "%"
					: "";
			if (type == "total")
				return this.SummaryreportsTable[0] != undefined
					? this.SummaryreportsTable[0].completed_total_score
					: "";
			if (type == "achieved")
				return this.SummaryreportsTable[0] != undefined
					? this.SummaryreportsTable[0].completed_current_score
					: "";
			if (type == "score")
				return this.SummaryreportsTable[0] != undefined
					? this.SummaryreportsTable[0]["completed_score_%"] + "%"
					: "";
			this.$forceUpdate();
			return this.SummaryreportsTable;
		},
		disableFromDatePickerDates(date) {
			if (!this.from_date) {
				return false;
			}
			return date < this.from_date;
		},
		downloadCsvReport() {
			this.addDownloadingReportCountAction("Report");
			this.is_csv_loading = true; //displayed loader on button
			// this.addDownloadingReportCountAction();
			var params = {
				start_date: moment(this.from_date).format("YYYY-MM-DD"),
				end_date: moment(this.to_date).format("YYYY-MM-DD"),
				project: this.project_tasks,
			};
			formBuilderServices
				.getDashboardDetailedReport(params)
				.then((response) => {
					// if (response.status == 200) {
					var fileURL = window.URL.createObjectURL(new Blob([response.data]));
					var fileLink = document.createElement("a");
					fileLink.href = fileURL;
					fileLink.setAttribute(
						"download",
						`${
							`${
								this.project_tasksItems.length != 0
									? this.project_tasksItems.filter((el) =>
											el.id.includes(this.project_tasks)
									  )[0].name
									: "-"
							} - ` +
							params.start_date +
							"/" +
							params.end_date +
							".csv"
						}`
					);
					document.body.appendChild(fileLink);
					fileLink.click();
					// }
					// this.removeDownloadingReportCountAction();
					this.removeDownloadingReportCountAction();
					this.is_csv_loading = false; //hide loader on button
				})
				.catch((err) => {
					console.log(err);
					this.removeDownloadingReportCountAction();
					this.is_csv_loading = false; //hide loader on button
					// this.abortDownloadingReportCountAction();
					this.$notify.error({
						title: "Error",
						message: "Something went wrong!",
					});
				});
		},
		exportCSV() {
			this.addDownloadingReportCountAction("Report");
			if (this.report_type == "Consolidated Report") {
				let data = [...this.reportsTable].map((el) => {
					let item = {
						"Location Id": el.store_id,
						Location: el.name,
						Region: el.region,
						"Sub Region": el.subregion,
						Occurence: el.total,
						Completed: el.completed,
					};
					if (this.show_completion) {
						item["Completion %"] = el["completion_%"];
					}
					if (this.show_score) {
						item["Score Completion %"] = el["completed_score_%"];
						item["Total Points"] = el["completed_total_score"];
						item["Points Achieved"] = el["completed_current_score"];
						// item["Average Score"] = el["completed_score_%"];
					}
					return item;
				});
				const fileName = `Consolidated Reports ${
					this.project_tasksItems.length != 0
						? this.project_tasksItems.filter((el) =>
								el.id.includes(this.project_tasks)
						  )[0].name
						: "-"
				} ( ${this.moment(this.from_date).format(
					"Do MMM YYYY"
				)} - ${this.moment(this.to_date).format("Do MMM YYYY")} )`;
				const exportType = exportFromJSON.types.csv;
				exportFromJSON({ data, fileName, exportType });
				this.removeDownloadingReportCountAction();
			}
			if (this.report_type == "Project / Task - Breakup Report") {
				var self = this;
				let data = [...self.reportsTable1].map((el) => {
					let item = {
						"Location Id": el.store_id,
						Location: el.store_name,
						"Project Start Date":
							el.project_start_date != 0
								? self.moment(el.project_start_date).format("Do MMM YYYY")
								: "-",
						"Project End Date":
							el.project_end_date != 0
								? self.moment(el.project_end_date).format("Do MMM YYYY")
								: "-",
						"Project Completion Date":
							el.project_completion_date != 0
								? self.moment
										.utc(el.project_completion_date)
										.local()
										.format("Do MMM YYYY")
								: "-",
						"Employee Id": el.emp_id,
						"Employee Name": el.name,
						Designation: el.designation,
						Region: el.region,
						"Sub Region": el.subregion,
						Status: el.status == "inprogress" ? "Incomplete" : "Completed",
					};
					if (self.show_completion) {
						item["Completion %"] = el["forms_completion_%"] + "%";
					}
					if (self.show_score) {
						item["Score Completion %"] = el["score_completion_%"];
						item["Points Available"] = el["total_score"];
						item["Points Achieved"] = el["current_score"];
						// item["Average Score"] = el["completed_score_%"] + "%";
					}
					return item;
				});
				const fileName = `Project / Task Breakup Reports ${
					self.project_tasksItems.length != 0
						? self.project_tasksItems.filter((el) =>
								el.id.includes(self.project_tasks)
						  )[0].name
						: "-"
				} ( ${moment(self.from_date).format("Do MMM YYYY")} - ${moment(
					self.to_date
				).format("Do MMM YYYY")} )`;
				const exportType = exportFromJSON.types.csv;
				exportFromJSON({ data, fileName, exportType });
				self.removeDownloadingReportCountAction();
			}
		},
		listCountries() {
			this.all_locations = [];
			formBuilderServices.getCountryList().then((res) => {
				this.locationItems = JSON.parse(res.data).results;
				let all_locations = [];
				this.locationItems.forEach((el) => {
					el.label = el.name;
					el.value = el.id;
					if (el.regions.length != 0) {
						el.children = el.regions;
						el.regions.forEach((elR) => {
							elR.label = elR.name;
							elR.value = elR.id;
							if (elR.subregions.length != 0) {
								elR.children = elR.subregions;
								elR.subregions.forEach((elS) => {
									elS.label = elS.name;
									elS.value = elS.id;
									if (elS.outlets.length != 0) {
										elS.children = elS.outlets;
										elS.outlets.forEach((elO) => {
											elO.label = elO.name;
											elO.value = elO.id;
										});
										all_locations.push(elS.outlets);
									}
								});
							}
						});
					}
				});
				// this.all_locations = all_locations.flat();
				// this.all_locations = this.all_locations.sort((a, b) =>
				// 	a.label.localeCompare(b.label)
				// );
			});
			formBuilderServices.listAllLocations().then((res) => {
				let all_locations = JSON.parse(res.data);
				this.all_locations = all_locations.sort((a, b) =>
					a.name < b.name ? -1 : 1
				);
			});
		},
		async listProjectsAndTasks() {
			formBuilderServices.getProjectsTasksList().then(async (res) => {
				let project_tasksItems = JSON.parse(res.data).data;
				this.project_tasksItems = project_tasksItems.sort((a, b) =>
					a.name < b.name ? -1 : 1
				);
				if (this.project_tasksItems.length != 0) {
					this.project_tasks = this.project_tasksItems[0].id;
					// await this.show_hide_reports();
					// await this.get_filelds_by_project();
					await this.getCategory(this.project_tasks);
					this.listDashboardData();
				}
			});
		},
		async get_filelds_by_project() {
			return new Promise((resolve, reject) => {
				try {
					this.show_fields = this.project_tasksItems
						.filter((el) => el.id == this.project_tasks)
						.map((el) => el.show_fields);
					this.show_completion = false;
					this.show_score = false;
					for (let i = 0; i < this.show_fields.length; i++) {
						if (this.show_fields[i].includes("completion_%")) {
							this.show_completion = true;
						}
						if (this.show_fields[i].includes("score_%")) {
							this.show_score = true;
						}
					}
					resolve(); // Resolve the promise once the operation is done
				} catch (error) {
					reject(error); // Reject the promise if there's an error
				}
			});
		},
		async show_hide_reports() {
			return new Promise((resolve, reject) => {
				try {
					for (let i = 0; i < this.project_tasksItems.length; i++) {
						if (this.project_tasksItems[i].id == this.project_tasks) {
							if (this.project_tasksItems[i].frequency == "quarterly") {
								this.reportItems = [
									{ name: "Week To Date", id: "week_to_date" },
									{ name: "Month To Date", id: "month_to_date" },
									{ name: "Year To Date", id: "year_to_date" },
									{ name: "Custom Date", id: "custom_date" },
									{ name: "Quarter On Quarter", id: "quarter_on_quarter" },
								];
							} else if (this.project_tasksItems[i].frequency == "monthly") {
								this.reportItems = [
									{ name: "Week To Date", id: "week_to_date" },
									{ name: "Month To Date", id: "month_to_date" },
									{ name: "Year To Date", id: "year_to_date" },
									{ name: "Custom Date", id: "custom_date" },
									{ name: "Month On Month", id: "month_on_month" },
								];
							} else {
								this.reportItems = [
									{ name: "Week To Date", id: "week_to_date" },
									{ name: "Month To Date", id: "month_to_date" },
									{ name: "Year To Date", id: "year_to_date" },
									{ name: "Custom Date", id: "custom_date" },
									{ name: "Month On Month", id: "month_on_month" },
									{ name: "Quarter On Quarter", id: "quarter_on_quarter" },
								];
							}
							resolve(); // Resolve the promise once the operation is done
						}
					}
				} catch (error) {
					reject(error); // Reject the promise if there's an error
				}
			});
		},
		async getCategory(id) {
			try {
				await this.show_hide_reports();
				this.category = "All";
				this.categoryItems = [];
				const res = await formBuilderServices.getCategoryList(id);
				this.categoryItems = JSON.parse(res.data).data;
				this.categoryItems.unshift({ name: "All", id: "All" });
				await this.get_filelds_by_project();
				this.listDashboardData();
			} catch (error) {
				// Handle any errors here
				console.error("Error in getCategory:", error);
			}
		},
		getForms(id) {
			this.listDashboardData();
			this.forms = "All";
			this.formItems = [];
			formBuilderServices.getFormsList(id).then((res) => {
				this.formItems = JSON.parse(res.data).data;
				this.formItems.unshift({ name: "All", id: "All" });
			});
		},
		listDashboardData() {
			this.is_outlet = false;
			this.isDomLoading = true;
			this.reportsTable = [];
			this.reportsTable1 = [];
			this.all_location_list = [];
			let from_date = moment(this.from_date).format("yyyy-MM-DD");
			let to_date = moment(this.to_date).format("yyyy-MM-DD");
			let params = {};
			let lastElement = [];
			let lastIndex = 0;
			if (this.view_by == "Location") {
				if (this.selectedLocationType == "region") {
					if (this.locations.length == 0) {
						this.locations = this.locationItems[0].id;
					} else {
						if (typeof this.locations != "string") {
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastIndex = j;
								}
							}
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastElement.push(this.locations[i][lastIndex]);
								}
							}
							lastElement = [...new Set(lastElement)].filter(Boolean);
						} else {
							lastElement = [this.locations];
							lastIndex = 0;
						}
					}
					params = {
						filters: {
							outlets: lastIndex == 3 ? lastElement : [],
							countries: lastIndex == 0 ? lastElement : [],
							regions: lastIndex == 1 ? lastElement : [],
							subregions: lastIndex == 2 ? lastElement : [],
						},
						start_date: from_date,
						end_date: to_date,
						project: this.project_tasks,
						form_category: this.category !== "All" ? this.category : null,
						form: this.forms !== "All" ? this.forms : null,
						basics:
							this.report_type == "Consolidated Report" ? "outlet" : "user",
						include_dates: false,
						get_country_avg: true,
					};
					if (this.reports == "month_on_month") params.aggregate_on = "month";
					if (this.reports == "quarter_on_quarter")
						params.aggregate_on = "quarter";
					if (this.selectedLocationType == "region") {
						if (lastIndex == 0) {
							params.basics = "region";
						}
						if (lastIndex == 1) {
							params.basics = "subregion";
						}
						if (lastIndex == 2) {
							params.basics = "outlet";
						}
						if (lastIndex == 3) {
							params.basics = "outlet";
						}
					}
				} else {
					if (this.locationItems[0].id == this.locations) {
						this.locations = [];
					}
					params = {
						filters: {
							outlets: this.locations,
							countries: [],
							regions: [],
							subregions: [],
						},
						start_date: from_date,
						end_date: to_date,
						project: this.project_tasks,
						form_category: this.category !== "All" ? this.category : null,
						form: this.forms !== "All" ? this.forms : null,
						basics:
							this.report_type == "Consolidated Report" ? "outlet" : "user",
						include_dates:
							this.report_type == "Consolidated Report" ? false : true,
						get_country_avg: true,
					};
					if (this.reports == "month_on_month") params.aggregate_on = "month";
					if (this.reports == "quarter_on_quarter")
						params.aggregate_on = "quarter";
				}
			}
			if (this.view_by == "User") {
				if (this.selectedLocationType == "region") {
					if (this.locations.length == 0) {
						this.locations = this.locationItems[0].id;
					} else {
						if (typeof this.locations != "string") {
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastIndex = j;
								}
							}
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastElement.push(this.locations[i][lastIndex]);
								}
							}
							lastElement = [...new Set(lastElement)];
						} else {
							lastElement = [this.locations];
							lastIndex = 0;
						}
					}
					params = {
						filters: {
							outlets: lastIndex == 3 ? lastElement : [],
							countries: lastIndex == 0 ? lastElement : [],
							regions: lastIndex == 1 ? lastElement : [],
							subregions: lastIndex == 2 ? lastElement : [],
						},
						start_date: from_date,
						end_date: to_date,
						project: this.project_tasks,
						form_category: this.category !== "All" ? this.category : null,
						form: this.forms !== "All" ? this.forms : null,
						basics: "user",
						include_dates: false,
						get_country_avg: true,
					};
					if (this.reports == "month_on_month") params.aggregate_on = "month";
					if (this.reports == "quarter_on_quarter")
						params.aggregate_on = "quarter";
				} else {
					if (this.locationItems[0].id == this.locations) {
						this.locations = [];
					}
					params = {
						filters: {
							outlets: this.locations,
							countries: [],
							regions: [],
							subregions: [],
						},
						start_date: from_date,
						end_date: to_date,
						project: this.project_tasks,
						form_category: this.category !== "All" ? this.category : null,
						form: this.forms !== "All" ? this.forms : null,
						basics: "user",
						include_dates:
							this.report_type == "Consolidated Report" ? false : true,
						get_country_avg: true,
					};
					if (this.reports == "month_on_month") params.aggregate_on = "month";
					if (this.reports == "quarter_on_quarter")
						params.aggregate_on = "quarter";
				}
			}
			formBuilderServices
				.getDashboardData(params)
				.then((res) => {
					this.summaryData = JSON.parse(res.data).summary;
					this.SummaryreportsTable = Array(
						JSON.parse(res.data).country_average
					);
					let list = [];
					list = JSON.parse(res.data).data;
					list = list.sort((a, b) => b["completion_%"] - a["completion_%"]);
					this.reportsTable = list;
					this.reportsTable1 = JSON.parse(res.data).data;
					if (this.selectedLocationType == "location") {
						this.is_outlet = true;
					}
					if (lastIndex == 2 || lastIndex == 3) {
						this.is_outlet = true;
					}
					if (
						this.reports == "month_on_month" ||
						this.reports == "quarter_on_quarter"
					) {
						this.groupByDates();
					} else {
						if (this.report_type == "Project / Task - Breakup Report") {
							this.reportsTable = [];
							this.reportsTable1 = [];
							this.reportsTable = JSON.parse(res.data).data;
							let reportsTable1 = JSON.parse(res.data).data;
							this.reportsTable1 = reportsTable1.sort(
								(a, b) =>
									moment(a.project_start_date).format("x") -
									moment(b.project_start_date).format("x")
							);
						}
						this.view_month_table = false;
						this.CountryAverege = Array(JSON.parse(res.data).country_average);
						this.isDomLoading = false;
					}
					this.$forceUpdate();
				})
				.catch((err) => {
					this.isDomLoading = false;
				});
		},
		get_table_data_row(item) {
			this.storeObj = {};
			this.storeObj = item;
			this.list_data_row_by_region(item);
		},
		list_data_row_by_region(item) {
			let lastElement = [];
			let lastIndex = 0;
			let from_date = moment(this.from_date).format("yyyy-MM-DD");
			let to_date = moment(this.to_date).format("yyyy-MM-DD");
			let params = {};
			if (this.selectedLocationType == "region") {
				for (let i = 0; i < this.locations.length; i++) {
					for (let j = 0; j < this.locations[i].length; j++) {
						lastIndex = j;
					}
				}
				for (let i = 0; i < this.locations.length; i++) {
					for (let j = 0; j < this.locations[i].length; j++) {
						lastElement.push(this.locations[i][lastIndex]);
					}
				}
				lastElement = [...new Set(lastElement)];
				params = {
					filters: {},
					start_date: from_date,
					end_date: to_date,
					project: this.project_tasks,
					form_category: this.category !== "All" ? this.category : null,
					form: this.forms !== "All" ? this.forms : null,
					basics:
						lastIndex == 3
							? "outlet"
							: lastIndex == 0
							? "region"
							: lastIndex == 1
							? "subregion"
							: lastIndex == 2
							? "outlet"
							: "",
					include_dates: false,
					get_country_avg: true,
					aggregate_on: "day",
				};
				if (params.basics == "region") {
					params.filters = {
						outlets: [],
						countries: [],
						regions: [item.basics],
						subregions: [],
					};
				}
				if (params.basics == "subregion") {
					params.filters = {
						outlets: [],
						countries: [],
						regions: [],
						subregions: [item.basics],
					};
				}
				if (params.basics == "outlet") {
					params.filters = {
						outlets: [item.basics],
						countries: [],
						regions: [],
						subregions: [],
					};
				}
			} else {
				params = {
					filters: {
						outlets: [item.basics],
						countries: [],
						regions: [],
						subregions: [],
					},
					start_date: from_date,
					end_date: to_date,
					project: this.project_tasks,
					form_category: this.category !== "All" ? this.category : null,
					form: this.forms !== "All" ? this.forms : null,
					basics: "outlet",
					include_dates: false,
					get_country_avg: true,
					aggregate_on: "day",
				};
			}
			this.storeObj.params = params;
			formBuilderServices.getDashboardData(params).then((res) => {
				this.storeObj.response = JSON.parse(res.data);
				if (this.is_outlet) {
					this.listusersData(item);
				} else {
					this.current_view = "Page_3";
					this.$emit("hide_upper_tabs");
					this.$forceUpdate();
				}
			});
		},
		get_dashboard_response() {
			this.listDashboardData();
			this.current_view = "Page_1";
			this.$emit("hide_upper_tabs_false");
		},
		get_dashboard_response_MoMQoQ() {
			this.listDashboardData();
			this.current_view = "Page_1";
			this.$emit("hide_upper_tabs_false");
		},
		open_report_dashboard(item, index, type) {
			this.storeObj = {};
			this.storeObj = item;
			if (!this.storeObj) {
				this.storeObj = {}; // Initialize as an empty object if it's undefined
			}
			this.storeObj.type = type;
			if (type == "TOTAL") {
				let from_date = moment(this.from_date).format("yyyy-MM-DD");
				let to_date = moment(this.to_date).format("yyyy-MM-DD");
				let params = {
					filters: {
						outlets: [],
						countries: [],
						regions: [],
						subregions: [],
					},
					start_date: from_date,
					end_date: to_date,
					project: this.project_tasks,
					form_category: null,
					form: null,
					basics: "country",
					include_dates: false,
					get_country_avg: true,
					aggregate_on: "day",
				};
				this.storeObj.params = params;
				formBuilderServices.getDashboardData(params).then((res) => {
					this.storeObj.response = JSON.parse(res.data);
					this.current_view = "Page_3";
					this.$emit("hide_upper_tabs");
					this.$forceUpdate();
				});
			}
			if (type == "ROW") this.list_data_row_by_region(item);
		},
		listusersData(item) {
			let from_date = moment(this.from_date).format("yyyy-MM-DD");
			let to_date = moment(this.to_date).format("yyyy-MM-DD");
			let params = {
				filters: {
					outlets: [item.basics],
					countries: [],
					regions: [],
					subregions: [],
				},
				start_date: from_date,
				end_date: to_date,
				project: this.project_tasks,
				form_category: this.category !== "All" ? this.category : null,
				form: this.forms !== "All" ? this.forms : null,
				basics: "user",
				include_dates: true,
				get_country_avg: true,
				get_region_avg: true,
			};
			formBuilderServices.getDashboardData(params).then((res) => {
				this.storeObj.response2 = JSON.parse(res.data).data;
				this.current_view = "Page_3";
				this.$emit("hide_upper_tabs");
				this.$forceUpdate();
			});
		},
		listReportsSwitchData() {
			if (this.report_type == "Detailed Report") {
				this.DialogDetailedReport = true;
				this.report_type = "Consolidated Report";
			} else {
				this.listDashboardData();
			}
		},
		downloadCsvReport() {
			this.addDownloadingReportCountAction("Report");
			this.is_csv_loading = true; //displayed loader on button
			// this.addDownloadingReportCountAction();
			let freq = [...this.project_tasksItems].filter((el) => {
				if (el.id == this.project_tasks) {
					return el.frequency;
				}
			});
			let days =
				freq[0].frequency == "daily"
					? 31
					: freq[0].frequency == "weekly"
					? 61
					: freq[0].frequency == "monthly"
					? 92
					: freq[0].frequency == "quarterly"
					? 92
					: 31;
			let to_date = moment(this.to_date).format("YYYY-MM-DD");
			let from_date = moment(to_date)
				.subtract(days, "days")
				.format("YYYY-MM-DD");
			var params = {
				start_date: from_date,
				end_date: to_date,
				project: this.project_tasks,
				location: null,
				locations: this.locations,
			};
			setTimeout(() => {
				this.$emit("close");
			}, 1000);
			formBuilderServices
				.getDashboardDetailedReport(params)
				.then((response) => {
					// if (response.status == 200) {
					var fileURL = window.URL.createObjectURL(new Blob([response.data]));
					var fileLink = document.createElement("a");
					fileLink.href = fileURL;
					fileLink.setAttribute(
						"download",
						`${
							`${
								this.project_tasksItems.length != 0
									? this.project_tasksItems.filter((el) =>
											el.id.includes(this.project_tasks)
									  )[0].name
									: "-"
							} - ` +
							params.start_date +
							"/" +
							params.end_date +
							".csv"
						}`
					);
					document.body.appendChild(fileLink);
					fileLink.click();
					// }
					// this.removeDownloadingReportCountAction();
					this.removeDownloadingReportCountAction();
					this.is_csv_loading = false; //hide loader on button
				})
				.catch((err) => {
					console.log(err);
					this.removeDownloadingReportCountAction();
					this.is_csv_loading = false; //hide loader on button
					// this.abortDownloadingReportCountAction();
					this.$notify.error({
						title: "Error",
						message: "Something went wrong!",
					});
				});
		},
	},
};
</script>

<style lang="scss">
.dashboard {
	background-color: #f6f7f9;
	width: 100%;
	margin: auto;
	.reports-table-hide {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			min-height: 60vh;
			max-height: 60vh;
			display: none;
		}
		.el-table__empty-block {
			display: none !important;
		}
	}
	.reports-table {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			min-height: 60vh;
			max-height: 60vh;
		}
		.el-table__empty-block {
			display: none !important;
		}
	}
	.reports-table1 {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table thead.is-group th.el-table__cell {
			background: white !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			overflow-x: auto;
			min-height: 62vh;
			max-height: 62vh;
		}
	}
}
.el-cascader .el-input .el-input__inner {
	border-radius: 12px;
}
.searchicon {
	border: 1px solid rgb(209, 203, 203);
}

//  Table styling

.overflow-table {
	width: 100% !important;
	overflow-x: auto !important;
}
.Table {
	width: 100%;
	border-collapse: collapse;
}

.Table th {
	text-align: left;
	text-transform: uppercase;
	font-weight: 600;
	color: var(--MutedColor);
	font-size: var(--FontSizeS1);
}

.Table td,
.Table th {
	padding: 15px 10px;
	text-align: left;
	border-top: none;
	border-bottom: 1px solid #ebeef5;
	font-size: 12px;
}

.TableWrapper {
	width: 100%;
	height: 100%;
	overflow: auto;
}

.TableWrapper thead {
	white-space: nowrap;
}

.StickyTable {
	border-collapse: separate;
	border-spacing: 0;
}

.StickyTable thead th {
	position: sticky;
	top: 0;
	background: var(--CardBG);
}

.StickyTable tfoot td {
	position: sticky;
	bottom: 0;
	background: var(--CardBG);
}
:root {
	--dynamic-width: 390px; /* Define the CSS variable */
}
.dynamic-width {
	text-align: center !important;
	min-width: 390px !important;
	max-width: 390px !important;
	width: var(
		--dynamic-width,
		auto
	) !important; /* Position the element absolutely */
}
.dynamic-width2 {
	text-align: center !important;
	min-width: 260px !important;
	max-width: 260px !important;
	width: var(--dynamic-width2, auto) !important;
}
.dynamic-widthh1 {
	text-align: center !important;
	min-width: 130px !important;
	max-width: 130px !important;
	width: var(--dynamic-widthh1, auto) !important;
}
.dynamic-widthh2 {
	text-align: center !important;
	min-width: 130px !important;
	max-width: 130px !important;
	width: var(--dynamic-widthh2, auto) !important;
}
.dynamic-widthh3 {
	text-align: center !important;
	min-width: 110px !important;
	max-width: 110px !important;
	width: var(--dynamic-widthh3, auto) !important;
}
.vertical-divider {
	border-right: 1px solid #ccc; /* Adjust the style of the divider as needed */
}
</style>
